import io from 'socket.io-client';
import { find, filter, forEach, map, groupBy, uniq, keyBy, cloneDeep } from 'lodash';
import { substituteQuickReplyVars } from '../../functions/quick-reply-vars';
import axios from 'axios';
import $ from 'jquery';
import qs from 'qs';
import { Loading, Message } from 'element-ui';
const SOCKET_URL = process.env.VUE_APP_SOCKET_URL; // 'https://mushbot-dev.softsq.com | http://localhost:3000'
const API_CHAT = process.env.VUE_APP_API_CHAT; //'https://mushbot.softsq.com/api'; // 'https://mushbot-dev.softsq.com/api | http://localhost:3000/api';
const API_SEARHPRODUCT = process.env.VUE_APP_API_SEARHPRODUCT;
const API_MUSH = process.env.VUE_APP_API_MUSH;
var TOUR_AUTO_LOGIN_URL = process.env.VUE_APP_TOUR_AUTO_LOGIN_URL;

const Root = localStorage.getItem('sitetpx'); //'https://m.tourprox.com'
if (Root == 'https://m.office.softsq.com/') {
  TOUR_AUTO_LOGIN_URL = Root + 'autologinforchatui.aspx';
}
let _socket = null;
let _promiseConnect = null;
const CancelToken = axios.CancelToken;

const Request = axios.create({
  headers: { 'Content-Type': 'application/json' },
});

const apiChat = axios.create({
  headers: { 'Content-Type': 'application/json' },
  baseURL: API_CHAT,
});

// Add request interceptor to automatically include Bearer token
apiChat.interceptors.request.use(
  config => {
    const token = window.sessionStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

const requests = [];

const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

// localStorage helpers for pending/failed messages persistence
const PENDING_MESSAGES_KEY = 'chatPendingMessages';

function getPendingMessages() {
  try {
    var data = localStorage.getItem(PENDING_MESSAGES_KEY);
    return data ? JSON.parse(data) : {};
  } catch (e) {
    return {};
  }
}

function savePendingMessage(custId, message) {
  var pending = getPendingMessages();
  if (!pending[custId]) {
    pending[custId] = [];
  }
  // Check if message already exists (by tempId)
  var existingIndex = pending[custId].findIndex(function (m) {
    return m.messageid === message.messageid;
  });
  if (existingIndex >= 0) {
    pending[custId][existingIndex] = message;
  } else {
    pending[custId].push(message);
  }
  localStorage.setItem(PENDING_MESSAGES_KEY, JSON.stringify(pending));
}

function removePendingMessage(custId, messageid) {
  var pending = getPendingMessages();
  if (pending[custId]) {
    pending[custId] = pending[custId].filter(function (m) {
      return m.messageid !== messageid;
    });
    if (pending[custId].length === 0) {
      delete pending[custId];
    }
    localStorage.setItem(PENDING_MESSAGES_KEY, JSON.stringify(pending));
  }
}

function getPendingMessagesForCustomer(custId) {
  var pending = getPendingMessages();
  return pending[custId] || [];
}

// localStorage helpers for message draft persistence per customer
const MESSAGE_DRAFTS_KEY = 'chatMessageDrafts';

function getMessageDrafts() {
  try {
    const data = localStorage.getItem(MESSAGE_DRAFTS_KEY);
    return data ? JSON.parse(data) : {};
  } catch (e) {
    return {};
  }
}

function saveMessageDraft(custId, text, suggestionId) {
  const drafts = getMessageDrafts();
  if ((text && text.trim()) || suggestionId) {
    drafts[custId] = { text: text || '', suggestionId: suggestionId || null };
  } else {
    delete drafts[custId];
  }
  localStorage.setItem(MESSAGE_DRAFTS_KEY, JSON.stringify(drafts));
}

function getMessageDraft(custId) {
  const drafts = getMessageDrafts();
  const draft = drafts[custId];
  // Backward compatibility: old format was just a string
  if (typeof draft === 'string') {
    return { text: draft, suggestionId: null };
  }
  return draft || { text: '', suggestionId: null };
}

// localStorage helpers for quick reply templates cache
const QUICK_REPLY_CACHE_KEY = 'quickReplyTemplates';

function getCachedQuickReplyTemplates() {
  try {
    const data = localStorage.getItem(QUICK_REPLY_CACHE_KEY);
    return data ? JSON.parse(data) : null;
  } catch (e) {
    return null;
  }
}

function cacheQuickReplyTemplates(templates) {
  try {
    localStorage.setItem(QUICK_REPLY_CACHE_KEY, JSON.stringify(templates));
  } catch (e) {
    // localStorage full or unavailable
  }
}

// Default templates (fallback when API is not available)
const defaultQuickReplyTemplates = [
  { code: 'GREETING', seq: 1, title: 'สวัสดีทักทายลูกค้า', content: 'Mushroom Travel สวัสดี#ค่ะ #AgentName ยินดีให้บริการ#ค่ะ', children: [] },
  { code: 'CHECK_TOUR', seq: 2, title: 'ขอเช็คโปรแกรมทัวร์', content: '#AgentName ขออนุญาตเช็คโปรแกรมทัวร์สักครู่นะ#คะ', children: [] },
  { code: 'OFFER_TOUR', seq: 3, title: 'ขอเสนอโปรแกรมทัวร์', content: 'ขออนุญาตนำเสนอโปรแกรมทัวร์ดังนี้#ค่ะ', children: [] },
  { code: 'CONFIRM_TOUR', seq: 4, title: 'ขอคอนเฟิร์มโปรแกรมทัวร์', content: 'ขออนุญาตคอนเฟิร์มการจองทัวร์ดังนี้#ค่ะ', children: [] },
  { code: 'REQ_INFO', seq: 5, title: 'ขอข้อมูลลูกค้า', content: 'รบกวนขอข้อมูลลูกค้าดังนี้#ค่ะ 1.ชื่อ นามสกุล 2.หมายเลขโทรศัพท์ 3.หมายเลขบัตรประชาชน 4.อีเมล์', children: [] },
  { code: 'VERIFY_INFO', seq: 6, title: 'แจ้งตรวจสอบข้อมูล', content: 'กรุณาตรวจสอบความถูกต้องของรายละเอียดโปรแกรม และวันเดินทางในเอกสารอีกครั้ง ก่อนทำการชำระค่าทัวร์#ค่ะ', children: [] },
  { code: 'REQ_PASSPORT', seq: 7, title: 'ขอข้อมูลPassport', content: '#AgentName รบกวนขอหน้าพาสปอร์ตของผู้เดินทาง#ค่ะ', children: [] },
  { code: 'VERIFY_PAYMENT', seq: 8, title: 'แจ้งตรวจสอบการชำระเงิน', content: 'หากทำการชำระเงินแล้ว สามารถส่งหลักฐานการชำระเงินส่งมาให้ทางไลน์ เราจะดำเนินการส่งใบรับเงินให้ หลังจากนั้นจะทำการนัดหมายการเดินทางให้#ค่ะ', children: [] },
  { code: 'SEND_ITINERARY', seq: 9, title: 'ขอส่งใบนัดหมาย', content: 'ขออนุญาตส่งใบนัดหมายการเดินทางให้ดังนี้#ค่ะ', children: [] },
  { code: 'THANK_YOU', seq: 10, title: 'ขอบคุณลูกค้า', content: 'หวังว่าจะได้มีโอกาสให้บริการคุณในทริปต่อไปนะ#คะ ขอบคุณ#ค่ะ', children: [] },
  { code: 'PAYMENT_LINK', seq: 11, title: 'แจ้งชำระเงิน', content: 'รบกวนกดลิงก์ และกรอกเบอร์โทรศัพท์ เพื่อเช็ครายละเอียดการจอง ชำระเงิน พร้อมแนบสลิปได้เลย#ค่ะ', children: [] },
];

/**
 * Merge global templates with reservation-specific templates.
 * - If reservation template code matches a level-1 code → add as child
 * - If no match → append as new level-1 item
 */
function mergeQuickReplyTemplates(globalTemplates, reservationTemplates) {
  const merged = cloneDeep(globalTemplates).map(t => ({
    ...t,
    children: t.children || [],
  }));

  if (reservationTemplates && reservationTemplates.length > 0) {
    reservationTemplates.forEach(rt => {
      const parent = merged.find(t => t.code === rt.code);
      if (parent) {
        parent.children.push(rt);
      } else {
        merged.push({ ...rt, children: [] });
      }
    });

    // Sort children by seq within each group
    merged.forEach(t => {
      t.children.sort((a, b) => a.seq - b.seq);
    });
  }

  // Sort level-1 by seq
  merged.sort((a, b) => a.seq - b.seq);
  return merged;
}

export default {
  namespaced: true,
  state: {
    connect: false,
    customers: [],
    customersLoading: false,
    messages: [],
    messagesLoading: false,
    activeChatCustomer: null,
    disableSendMessage: false,
    disableSendMessageReason: '',
    lastMessage: null,
    newMessage: null,
    msgSuccess: '',
    msgCount: 0,
    searchCustomersMessage: [],
    searchContactCustomer: [],
    quickReplyTemplates: [],
    quickReplyExpandedCode: null,
    quickReplyLoading: false,
    customerSelf: true,
    customerTeams: '',
    customerTeam: 'a',
    msgId: null,
    firstMessage: null,
    scrollStatus: null,
    messageScroll: [],
    lastCustomer: null,
    msgCountAll: null,
    paidCountAll: 0,
    unpaidCountAll: 0,
    productDetail: null,
    mouthProduct: [],
    periodsProduct: null,
    productLoading: false,
    refLoading: false,
    listRefBooking: [],
    loadMore: false,
    isMobileMode: false,
    customersLoadMoreLoading: false,
    numPeriods: [],
    sickersAndOftenImage: [],
    typeOpenChat: false,
    loading: false,
    hasNewCustomer: false,
    newCustomerList: [],
    pushNextCustomerOnLoad: false,
    searchNotResponse: false,
    receiveNewCustNoti: 'false',
    autoLoginUrl: TOUR_AUTO_LOGIN_URL || '',
    serverConfig: {
      updated: false,
      bot: '',
      assign_customer: '',
    },
    quoteMessageFocused: null,
    messageReplying: null,
    reservationteam: null,
    // AI Suggestion state
    aiSuggestions: [],
    aiSuggestLoading: false,
    aiSuggestGlobalEnabled: true,         // Feature available (SUGGEST_MESSAGE_ENABLED)
    aiSuggestAutoTriggerEnabled: false,   // Auto-trigger enabled globally
    aiSuggestCustomerEnabled: false,      // Effective auto-trigger for this customer
    // Customer message edit (admin-only affordance, toggled via window.enableEdit)
    editMessageEnabled: false,
  },
  mutations: {
    patchMessageId(state, { oldId, newId, chatHistoryId }) {
      if (!oldId || !newId) {
        return;
      }
      const newList = [...state.messages];
      for (const msg of newList) {
        if (msg.messageid == oldId || msg.messageId == oldId) {
          const patch = { messageid: newId, messageId: newId };
          if (chatHistoryId) {
            patch.chatHistoryId = chatHistoryId;
          }
          Object.assign(msg, patch);
        }
      }
      state.messages = [...newList];
    },
    IS_MOBILE_MODE(state, value) {
      state.isMobileMode = value;
    },
    SOCKET_CONNECT(state, socket) {
      console.log('chat/connected: ', socket);
      state.connect = true;
      _socket = socket;
    },
    SOCKET_CUSTOMERS(state, customers) {
      // Get all pending messages from localStorage
      var allPending = getPendingMessages();

      state.customers = customers.map(v => {
        v.refCode = [];
        v.BookingId = 0;
        v.tags = [];

        // Merge localStorage failed message count with server count
        var localPending = allPending[v.custId] || [];
        var localFailedCount = localPending.filter(function (m) {
          return m.pushStatus === 'failed';
        }).length;

        if (localFailedCount > 0) {
          v.hasFailedMessages = true;
          v.failedMessageCount = (v.failedMessageCount || 0) + localFailedCount;
        }

        return v;
      });
      state.customersLoading = false;
    },
    SET_CUSTOMER_SEARCHTAG(state, item) {
      state.customers = item.data.map(v => {
        v.refCode = [];
        v.BookingId = 0;
        v.tags = item.tags;
        return v;
      });
      state.customersLoading = false;
    },
    SOCKET_NEW_CUSTOMER(state, customer) {
      state.customers = [...state.customers, customer];
    },
    SOCKET_MESSAGES(state, messages) {
      state.messages = messages.map(fnSetMessageModel).reverse();
    },
    messages(state, messages) {
      state.messages = [...messages];
    },
    disableSendMessage(state, { value, reason }) {
      state.disableSendMessage = value;
      if (value == true) {
        state.disableSendMessageReason = reason;
      } else {
        state.disableSendMessageReason = '';
      }
    },
    SOCKET_SET_MOREMES(state, messages) {
      // check dup message loaded
      const keys = keyBy(
        state.messages.map(m => ({ id: m.messageId })),
        'id',
      );

      var setMessage = messages.filter(m => !keys[m.messageId]).reverse();
      state.messages = [...setMessage, ...state.messages];
    },
    SET_LAST_CUSTOMER(state, customer) {
      state.lastCustomer = customer;
    },
    API_SET_MORECUS(state, customers) {
      state.customers = [...state.customers, ...customers];
      state.customersLoading = false;
      state.customersLoadMoreLoading = false;
    },
    // SET_CUSTOMER_SEARCHTAG(state, item) {
    //   state.customers = item.data.map(v => {
    //     v.refCode = [];
    //     v.BookingId = 0;
    //     v.tags = item.tags;
    //     return v;
    //   });
    //   state.customersLoading = false;
    // }
    SET_READ_CUSTOMER_COUNT(state, data) {
      // emitted from client.emit('updateMessage') > server.broadcast('readCustomerMessageId')
      let msg = find(state.customers, { custId: data.customerId });
      if (msg) {
        msg.count = 0;
      }
    },
    SET_READ_CUSTOMER(state, lastMessage) {
      // emitted from server.emit('readCustomerMessage');
      let msg = find(state.customers, { custId: lastMessage.custId });
      // ถ้าเป็นข้อมูลเก่ากว่า หรือถ้าเป็นชุดเดิม ให้ update ข้อมูลได้ เพราะจะมีข้อมูลเพิ่มเติมส่วน reservationMain
      if (msg && msg.lastMessageTime <= lastMessage.lastMessageTime) {
        Object.assign(msg, lastMessage);
      }
    },
    SET_RESERVATION_MESSAGE(state, { lastMessage, chatMessage }) {
      // update last message
      let msg = find(state.customers, { custId: lastMessage.custId });
      if (msg && msg.lastMessageTime < lastMessage.lastMessageTime) {
        Object.assign(msg, lastMessage);
      } else {
        //console.log('state message', msg);
        //console.log('lastMessage', lastMessage);
        //console.log('chatMessage', chatMessage);
      }

      const chatMessagePush = fnSetMessageModel(chatMessage);
      // update active chatbox
      if (
        state.activeChatCustomer &&
        state.activeChatCustomer.custId == chatMessage.custId &&
        (!state.newMessage ||
          (state.newMessage._id !== chatMessage._id &&
            state.newMessage.time <= chatMessage.time))
      ) {
        if (state.scrollStatus != 'Down') {
          state.messageScroll.push(chatMessagePush);
          state.newMessage = chatMessagePush;
        }

        // Check duplicate: skip if message with same text/sender already exists recently
        // This prevents double display when local optimistic message was already added via SOCKET_NEW_MESSAGE
        let duplicate = false;
        if (state.messages && state.messages.length > 0) {
          for (let i = state.messages.length - 1; i >= Math.max(0, state.messages.length - 5); i--) {
            const existing = state.messages[i];
            if (
              existing.sender === chatMessagePush.sender &&
              existing.msg === chatMessagePush.msg &&
              Math.abs((existing.time || 0) - (chatMessagePush.time || 0)) < 15000
            ) {
              // Update the existing message's IDs to match the server response
              if (chatMessage.messageId) {
                existing.messageId = chatMessage.messageId;
                existing._id = chatMessage.messageId;
                existing.messageid = chatMessage.messageId;
              }
              // Preserve MongoDB ObjectId from server (chatMessage._id from getChatHistory)
              if (chatMessage._id && typeof chatMessage._id === 'string' && /^[a-f0-9]{24}$/.test(chatMessage._id)) {
                existing.chatHistoryId = chatMessage._id;
              }
              if (chatMessage.pushStatus) {
                existing.pushStatus = chatMessage.pushStatus;
              }
              duplicate = true;
              break;
            }
          }
        }
        if (!duplicate) {
          state.messages.push(chatMessagePush);
        }
      }
    },
    SOCKET_First_MESSAGES(state, message) {
      state.firstMessage = message;
    },
    SOCKET_NEW_MESSAGE(
      state,
      {
        text,
        msg,
        nickname,
        isType,
        custid,
        custId,
        mappingId,
        time,
        type,
        custName,
        custImage,
        resId,
        resNickname,
        sender,
        isBot,
        custNameNew,
        messageid,
        messageId,
        count,
        firstMessageRead,
        lastMessageTime,
        latestUpdated,
        reservationMain,
        statusSendMessage,
        channelName,
        quotedMessageContent,
        quotedMessageSender,
        quotedMessageId,
        quoteToken,
        pushStatus,
        pushError,
        pushAttempts,
        chatHistoryId,
      },
    ) {
      let message = {
        count,
        user: resId,
        msg: text || msg,
        name: nickname,
        isType,
        custId: custid || custId,
        mappingId,
        time: time || new Date().getTime(),
        type: type || 'string',
        custName,
        resId,
        resNickname,
        sender,
        isBot,
        custImage,
        custNameNew,
        messageid,
        messageId: messageId || messageid,
        _id: messageId || messageid,
        chatHistoryId,
        firstMessageRead,
        lastMessageTime,
        latestUpdated,
        reservationMain,
        statusSendMessage,
        channelName,
        quotedMessageContent,
        quotedMessageSender,
        quotedMessageId,
        quoteToken,
        pushStatus: pushStatus || 'pending',
        pushError: pushError || null,
        pushAttempts: pushAttempts || 0,
      };
      let customer;

      if (state.searchCustomersMessage.length > 0) {
        customer = find(state.searchCustomersMessage, {
          custId: message.custId,
        });
      } else {
        customer = find(state.customers, { custId: message.custId });
      }

      // set
      if (
        state.activeChatCustomer &&
        state.activeChatCustomer.custId == message.custId
      ) {
        // check duplicate message from socket (committed from ui before api called)
        let duplicate = false;
        if (state.messages && state.messages.length > 0) {
          let lastMsg = state.messages[state.messages.length - 1].msg;
          let lastSender = state.messages[state.messages.length - 1].sender;
          let oldlatestUpdated =
            state.messages[state.messages.length - 1].latestUpdated;
          let newlatestUpdated = message.latestUpdated;
          let timeDiffMsg =
            new Date(newlatestUpdated).getTime() -
            new Date(oldlatestUpdated).getTime();
          if (
            timeDiffMsg < 10000 &&
            lastSender === message.sender &&
            lastMsg === message.msg
          ) {
            duplicate = true;
          }
        }

        console.log('socket new message', messageid);

        if (!duplicate) {
          state.messages = [...state.messages, fnSetMessageModel(message)];
          state.msgId = message.messageid;
        }
      }

      //
      if (customer) {
        if (!message.isBot) {
          customer.isBot = false;
        }
        if (
          state.activeChatCustomer &&
          state.activeChatCustomer.custId == message.custId
        ) {
          customer.count = 0;
        } else {
          customer.count = customer.count + 1;
        }
        customer.custImage = message.custImage || customer.custImage;
        customer.latestMsg = message.msg;
        customer.sender = message.sender || sender || 'C';
        customer.type = message.type || 'string';
        customer.latestUpdated = message.latestUpdated;
      } else {
        customer = message;
        customer.msgCount = message.count;
        customer.latestMsg = message.msg;
        customer.sender = message.sender || sender || 'C';
        customer.type = message.type || 'string';
        customer.latestUpdated = new Date(message.time);
        state.customers.push(customer);
      }

      if (state.scrollStatus != 'Down') {
        if (
          state.activeChatCustomer &&
          state.activeChatCustomer.custId == message.custId
        ) {
          state.messageScroll.push(message);
        }
      }
      //console.log(message);
      state.newMessage = message;

      if (message.sender == 'C') {
        state.disableSendMessage = false;
        state.disableSendMessageReason = '';
      }
    },
    SOCKET_DISCONNECT(state) {
      console.log('chat/disconnected!!');
      state.connect = false;
      _socket.close();
    },
    LOADING(state, { stateName, status }) {
      state[stateName + 'Loading'] = status;
    },
    SET_ACTIVE_CHAT_CUSTUMER(state, customer) {
      if (customer) {
        customer.count = 0;
        window.parent.postMessage({ openChat: customer.custId }, '*');
        state.activeChatCustomer = { ...customer };
      } else {
        state.activeChatCustomer = null;
      }
      state.messageReplying = null;
    },
    activeChatCustomer(state, payload) {
      state.activeChatCustomer = payload;
    },
    SOCKET_LAST_MESSSAGE(state, lastMessage) {
      state.lastMessage = lastMessage;
    },
    SOCKET_SEND_MESSAGE_SUCCESS(state, text) {
      state.msgSuccess = text;
    },
    COUNT_MESSAGE(state) {
      state.msgCount = fnCountMsgAll(state.customers);
    },
    SOCKET_SEARCH_MESSAGES(state, message) {
      state.searchCustomersMessage = message;
    },
    UPDATE_NAME_CUSTUMER(state, cust) {
      if (state.customers.length > 0) {
        const customer = find(state.customers, { custId: cust.customerid });
        customer.custNameNew = cust.displayname;
      }
    },
    SET_QUICK_REPLY_TEMPLATES(state, templates) {
      state.quickReplyTemplates = templates;
    },
    SET_QUICK_REPLY_EXPANDED(state, code) {
      state.quickReplyExpandedCode = state.quickReplyExpandedCode === code ? null : code;
    },
    SET_QUICK_REPLY_LOADING(state, loading) {
      state.quickReplyLoading = loading;
    },
    SCROLL_SATUSE(state, scroll) {
      state.scrollStatus = scroll;
    },
    MESSAGE_SCROLL(state, msg) {
      state.messageScroll = msg;
    },
    SOCKEt_COUNT_MESSAGEALL(state, count) {
      state.msgCountAll = count;
    },
    API_SEARCH_CONTACT(state, message) {
      state.searchContactCustomer = message;
    },
    API_SEARCH_PRODUCT(state, data) {
      if (data) {
        let mouth = uniq(
          map(data.period, function (val) {
            return { m: val.mouthCode, d: val.dayCode, id: val.period_id };
          }),
        );
        var grouped = groupBy(mouth, 'm');
        var arrayMouth = map(grouped, function (value, index) {
          return { mouths: index, ranges: fnCheckDayrank(index, value) };
        });
        state.mouthProduct = arrayMouth;
        state.productDetail = data;
        state.productLoading = false;
      } else {
        state.mouthProduct = [];
        state.productDetail = null;
        state.productLoading = false;
      }
    },
    SET_PERIOD_PRODUCT(state, text) {
      state.periodsProduct = text;
    },
    SET_PRODUCT_LOADING(state, status) {
      state.productLoading = status;
    },
    SET_LIST_REFBOOKING(state, obj) {
      if (state.activeChatCustomer.custId == obj.custId) {
        if (state.activeChatCustomer.refCode.indexOf('MUSH' + obj.ref) === -1) {
          state.activeChatCustomer.refCode = [
            ...state.activeChatCustomer.refCode,
            'MUSH' + obj.ref,
          ];
        }
      }
    },
    SET_BOOKING_CUSTOMER(state, bookingId) {
      // เพิ่มไม่ให้ clear ค่าออก
      if (!state.activeChatCustomer.BookingId || bookingId < 0) {
        // ถ้าติดลบ จะ force set
        state.activeChatCustomer.BookingId = Math.abs(bookingId);
      }
    },
    API_SET_CODE(state, data) {
      if (state.activeChatCustomer && state.activeChatCustomer.custId) {
        state.activeChatCustomer.refCode = [...data];
      }
    },
    SET_LOADING_REF(state, status) {
      state.refLoading = status;
    },
    SET_NO_SEND_MESSAGE(state, data) {
      state.messages = [
        ...forEach(state.messages, function (val) {
          if (val.time == state.newMessage.time && val.sender == 'R') {
            val.statusSendMessage = data;
          }
        }),
      ];
    },
    UPDATE_MESSAGE_PUSH_STATUS(state, { messageid, pushStatus, pushError, pushAttempts }) {
      const index = state.messages.findIndex(
        val => (val.messageId === messageid || val.messageid === messageid) && val.sender === 'R'
      );
      if (index !== -1) {
        // Use splice for Vue 2 reactivity
        const message = state.messages[index];
        state.messages.splice(index, 1, {
          ...message,
          pushStatus,
          pushError,
          pushAttempts,
          statusSendMessage: pushStatus !== 'failed', // backward compat
        });
      }
    },
    REMOVE_MESSAGE(state, messageid) {
      const index = state.messages.findIndex(
        val => val.messageId === messageid || val.messageid === messageid
      );
      if (index !== -1) {
        state.messages.splice(index, 1);
      }
    },
    SET_EDIT_MESSAGE_ENABLED(state, enabled) {
      state.editMessageEnabled = !!enabled;
    },
    PATCH_MESSAGE_CONTENT(state, { chatHistoryId, messageId, msg, type }) {
      const list = state.messages;
      for (let i = 0; i < list.length; i++) {
        const m = list[i];
        const matchByHistory = chatHistoryId && m.chatHistoryId === chatHistoryId;
        const matchByMsgId = messageId && (m.messageId === messageId || m.messageid === messageId);
        if (matchByHistory || matchByMsgId) {
          if (msg !== undefined) m.msg = msg;
          if (type) m.type = type;
          break;
        }
      }
      state.messages = [...list];
    },
    // Add message without updating customer list (for localStorage messages)
    ADD_LOCAL_MESSAGE(state, message) {
      state.messages = [...state.messages, fnSetMessageModel(message)];
    },
    UPDATE_CUSTOMER_ERROR_STATUS(state, { custId, hasFailedMessages, failedMessageCount, latestMsg }) {
      const customer = state.customers.find(c => c.custId === custId);
      if (customer) {
        customer.hasFailedMessages = hasFailedMessages;
        customer.failedMessageCount = failedMessageCount;
        if (latestMsg !== undefined) {
          customer.latestMsg = latestMsg;
        }
      }
    },
    UPDATE_RESEND_MESSAGE(state, data) {
      state.messages.splice(state.messages.indexOf(data), 1);
    },
    SET_LOAD_MORE(state, data) {
      state.loadMore = data;
    },
    SET_TYPE_CHAT(state, data) {
      state.typeOpenChat = data;
    },
    SET_NUM_PERIODS(state, data) {
      if (data) {
        state.numPeriods.push(data);
      } else {
        state.numPeriods = [];
      }
    },
    SET_STICKERS_AND_OFTENIMAGE(state, data) {
      state.sickersAndOftenImage = data;
    },
    customerSelf(state, data) {
      state.customerSelf = data;
    },
    customerTeams(state, data) {
      state.customerTeams = data;
    },
    customerTeam(state, data) {
      state.customerTeam = data;
    },
    loading(state, data) {
      state.loading = data;
    },
    hasNewCustomer(state, data) {
      state.hasNewCustomer = data;
    },
    newCustomerList(state, data) {
      state.newCustomerList = [...data];
    },
    pushNextCustomerOnLoad(state, data) {
      state.pushNextCustomerOnLoad = data;
    },
    searchNotResponse(state, data) {
      state.searchNotResponse = data;
    },
    customers(state, data) {
      state.customer = [...data];
    },
    receiveNewCustNoti(state, data) {
      state.receiveNewCustNoti = data;
      localStorage.setItem('receiveNewCustNoti', String(data).toLowerCase());
    },
    serverConfig(state, data) {
      state.serverConfig = { ...state.serverConfig, ...data, updated: true };
    },
    quoteMessageFocused(state, data) {
      state.quoteMessageFocused = data;
    },
    messageReplying(state, data) {
      state.messageReplying = data;
    },
    SET_RESERVATION_TEAM(state, value) {
      state.reservationteam = value;
    },
    SET_PAIDCOUNT(state, count) {
      state.paidCountAll = count;
    },
    SET_UNPAIDCOUNT(state, count) {
      state.unpaidCountAll = count;
    },
    // AI Suggestion mutations
    SET_AI_SUGGESTIONS(state, suggestions) {
      state.aiSuggestions = suggestions;
    },
    ADD_AI_SUGGESTION(state, suggestion) {
      // Check if suggestion already exists by suggestionId
      const exists = state.aiSuggestions.find(s => s.suggestionId === suggestion.suggestionId);
      if (!exists) {
        // Manual suggestions always go to top, auto suggestions append to bottom
        if (suggestion.source === 'manual') {
          state.aiSuggestions = [suggestion, ...state.aiSuggestions];
        } else {
          state.aiSuggestions = [...state.aiSuggestions, suggestion];
        }
      }
    },
    CLEAR_AI_SUGGESTIONS(state) {
      state.aiSuggestions = [];
    },
    SET_AI_SUGGEST_LOADING(state, loading) {
      state.aiSuggestLoading = loading;
    },
    SET_AI_SUGGEST_GLOBAL_ENABLED(state, enabled) {
      state.aiSuggestGlobalEnabled = enabled;
    },
    SET_AI_SUGGEST_AUTO_TRIGGER_ENABLED(state, enabled) {
      state.aiSuggestAutoTriggerEnabled = enabled;
    },
    SET_AI_SUGGEST_CUSTOMER_ENABLED(state, enabled) {
      state.aiSuggestCustomerEnabled = enabled;
    },
    UPDATE_AI_SUGGESTION_FEEDBACK(state, { suggestionId, isCorrect }) {
      const suggestion = state.aiSuggestions.find(s => s.suggestionId === suggestionId);
      if (suggestion) {
        suggestion.feedback = { isCorrect };
      }
    },
    REMOVE_AI_SUGGESTION(state, suggestionId) {
      state.aiSuggestions = state.aiSuggestions.filter(s => s.suggestionId !== suggestionId);
    },
  },
  actions: {
    init({ dispatch }) {
      dispatch('getPublicConfig');
    },
    setReply({ commit }, currentMessage) {
      commit('messageReplying', currentMessage);
      document.getElementById('chat-input').focus();
    },
    async setReceiveNewCustNoti({ commit, dispatch }, value) {
      // Update the state
      if (value === 'true' && Notification.permission !== 'granted') {
        Notification.requestPermission().then(() => {
          if (Notification.permission === 'denied') {
            commit('receiveNewCustNoti', 'false');
            // Update localStorage
            localStorage.setItem('receiveNewCustNoti', 'false');
            return;
          }
        });
      }
      commit('receiveNewCustNoti', value);
      // Update localStorage
      localStorage.setItem('receiveNewCustNoti', value);
    },
    connect({ commit, rootState, state, dispatch }) {
      if (_promiseConnect) {
        return _promiseConnect;
      } else {
        _promiseConnect = new Promise(resolve => {
          const socket = io.connect(SOCKET_URL, {
            transports: ['websocket'],
          });
          // Define a function to handle reconnection
          function handleReconnection() {
            let isConnected = socket.connected;
            const reconnectInterval = 1000; // Set the reconnection interval (1 second)

            // Check the socket connection status periodically
            setInterval(() => {
              // If the socket is not connected, try to reconnect
              if (!isConnected) {
                console.log('Trying to reconnect...');
                socket.connect();
              }

              // Update the connection status
              isConnected = socket.connected;
            }, reconnectInterval);
          }

          socket.on('connect', () => {
            socket.emit('mapsocket', socket.id, rootState.reservationId);
            socket.emit('countmessageunread', rootState.reservationId);
            commit('SOCKET_CONNECT', socket);
            console.log('SOCKET_CONNECT');

            const receiveNoti =
              localStorage.getItem('receiveNewCustNoti') || 'false';
            dispatch('setReceiveNewCustNoti', receiveNoti);
            resolve();
          });
          socket.on('listcustomer', function (data) {
            commit('SOCKET_CUSTOMERS', data);
          });
          socket.on('newlistcustomer', function (customer) {
            commit('SOCKET_NEW_CUSTOMER', customer);
          });
          socket.on('reloadreservation', function (data) {
            commit('SOCKET_CUSTOMERS', data);
          });
          socket.on('listhistory', function (data) {
            commit('SOCKET_MESSAGES', data);
          });

          socket.on('customersend', function (data) {
            console.log('cust send');
            if (!data[0].reservationMain.reservationId) {
              // ข้อความใหม่ที่ยังไม่มี reservation ดูแล จะไม่เข้ากล่องข้อความ
              // reservation ต้องกดรับลูกค้าก่อน
              return;
            }
            if (!state.customerSelf) {
              commit('SOCKET_NEW_MESSAGE', data[0]);
            } else if (state.customerTeam !== '') {
              commit('SOCKET_NEW_MESSAGE', data[0]);
            } else if (
              data[0].reservationMain.reservationId == rootState.reservationId
            ) {
              // ถ้าแสดงของตัวเอง ให้เช็คว่ายังไม่มี resmain หรือ resmain ต้องตรงกับตนเอง
              commit('SOCKET_NEW_MESSAGE', data[0]);
            }
          });
          socket.on('hasNewCustomer', async function (data) {
            // if (data && state.receiveNewCustNoti == 'true') {
            //   new Notification('Mushroomtravel Chat', {
            //     body: `มีลูกค้าใหม่`,
            //   });
            // }
            // commit('hasNewCustomer', data);

            await dispatch('getNextNewCustomerUnread');
            const newCustomerListFiltered = [
              ...state.newCustomerList.filter(
                c => c.customer.customerId !== data.customerId,
              ),
            ];
            commit('newCustomerList', newCustomerListFiltered);
            commit('hasNewCustomer', newCustomerListFiltered.length > 0);
            if (
              data &&
              state.receiveNewCustNoti == 'true' &&
              newCustomerListFiltered.length > 0
            ) {
              new Notification('Mushroomtravel Chat', {
                body: `มีลูกค้าใหม่`,
              });
            }
          });
          socket.on('newCustomerAssigned', function (customerId) {
            // if (data && state.receiveNewCustNoti == 'true') {
            //   new Notification('Mushroomtravel Chat', {
            //     body: `มีลูกค้าใหม่`,
            //   });
            // }
            // commit('hasNewCustomer', data);
            if (customerId && state.receiveNewCustNoti == 'true') {
              new Notification('Mushroomtravel Chat', {
                body: 'มีลูกค้าใหม่ (จ่ายงานอัตโนมัติ)',
              });
            }

            setTimeout(function () {
              dispatch('loadCustomers');
            }, 1500);
          });
          socket.on('rejectCustomer', function ({ customerId, newOwner }) {
            if (state.customerSelf && rootState.reservationId !== newOwner) {
              if (
                state.activeChatCustomer &&
                state.activeChatCustomer.custId == customerId
              ) {
                commit('SET_ACTIVE_CHAT_CUSTUMER', null);
              }
              // filter out
              const filteredCustomer = state.customers.filter(
                c => c.custId !== customerId,
              );
              commit('SOCKET_CUSTOMERS', filteredCustomer);
            }
          });
          socket.on('configurationChanged', function (data) {
            console.log('new server config', data);
            commit('serverConfig', data);
          });
          socket.on('disconnect', function () {
            commit('SOCKET_DISCONNECT', socket);
            handleReconnection();
          });
          socket.on('messageSuccess', function (data) {
            commit('SOCKET_SEND_MESSAGE_SUCCESS', data);
          });
          socket.on('readCustomerMessage', data => {
            commit('SET_READ_CUSTOMER', fnSetMessageModel(data));
          });
          socket.on('readCustomerMessageId', data => {
            commit('SET_READ_CUSTOMER_COUNT', data);
          });
          socket.on('reservationSend', data => {
            commit('SET_RESERVATION_MESSAGE', data);
          });
          // socket.on('countmessageunread', function(data) {
          //   console.log('count messge>>>>', data);
          //   commit('SOCKEt_COUNT_MESSAGEALL', data[0].count);
          // });

          socket.on('setResMain', async data => {
            await dispatch('getNextNewCustomerUnread');
            const newCustomerListFiltered = [
              ...state.newCustomerList.filter(
                c => c.customer.customerId !== data.customerId,
              ),
            ];
            commit('newCustomerList', newCustomerListFiltered);
            commit('hasNewCustomer', newCustomerListFiltered.length > 0);
          });

          // AI Suggestion Socket listeners
          socket.on('suggestionReady', data => {
            console.log('suggestionReady received:', data);
            // Only add if for active customer
            if (
              state.activeChatCustomer &&
              state.activeChatCustomer.custId === data.customerId
            ) {
              commit('ADD_AI_SUGGESTION', {
                suggestionId: data.suggestionId,
                messageId: data.messageId,
                chatHistoryId: data.chatHistoryId,
                chatHistoryIds: data.chatHistoryIds || (data.chatHistoryId ? [data.chatHistoryId] : []),
                customerId: data.customerId,
                suggestedReply: data.suggestedReply,
                alternativeReplies: data.alternativeReplies || [],
                intent: data.intent,
                confidence: data.confidence,
                flowName: data.flowName,
                pageName: data.pageName,
                feedback: { isCorrect: null },
                used: data.used || { isUsed: false },
                source: data.source || 'auto',
                customerMessageAt: data.customerMessageAt,
              });
            }
          });

          socket.on('suggestionsList', data => {
            console.log('suggestionsList received:', data);
            const suggestions = (data || []).map(s => ({
              suggestionId: s._id,
              messageId: s.messageId,
              chatHistoryId: s.chatHistoryId,
              chatHistoryIds: s.chatHistoryIds || (s.chatHistoryId ? [s.chatHistoryId] : []),
              customerId: s.customerId,
              suggestedReply: s.suggestedReply,
              alternativeReplies: s.alternativeReplies || [],
              intent: s.detectedIntent,
              confidence: s.intentConfidence,
              feedback: s.feedback || { isCorrect: null },
              source: s.source || 'auto',
              createdAt: s.createdAt,
              customerMessageAt: s.customerMessageAt,
            }));
            // Sort by createdAt ascending (oldest on top)
            suggestions.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
            // Manual suggestions go on top, then auto sorted by date
            const existingManual = state.aiSuggestions.filter(
              s => s.source === 'manual' && !suggestions.find(ns => ns.suggestionId === s.suggestionId)
            );
            commit('SET_AI_SUGGESTIONS', [...existingManual, ...suggestions]);
          });
        });
        return _promiseConnect;
      }
    },
    disconnect({ commit }) {
      commit('SOCKET_DISCONNECT');
    },
    mapSocket({ rootState }) {
      if (!_socket) {
        throw new Error("chat socket don't have connection");
      }
      if (!rootState.reservationId) {
        throw new Error('Reservation Id is invalid');
      }
      _socket.emit('mapsocket', _socket.id, rootState.reservationId);
    },
    async loadCustomers({ state, dispatch, rootState, commit }) {
      if (!_socket) {
        throw new Error("chat socket don't have connection");
      }
      if (!rootState.reservationId) {
        throw new Error('Reservation Id is invalid');
      }

      // commit('LOADING', {
      //   stateName: 'customers',
      //   status: true,
      // });

      commit('loading', true);

      commit('SOCKET_CUSTOMERS', []);

      const customerSelf = state.customerSelf; // เอาไว้ส่งค่าเช็ค ตอนที่จะ update state เพราะบางทีโหลดช้า แล้วข้อมูลทับกัน
      //var customerTeam = '';
      // const ResTeam  = {
      //   "a": "7445,15502,14158,7408,14576,15793,15668,15132",
      //   "b": "12257,15793,15792,14600,14175,15518,15667"
      // };

      const ResTeam = fnLoadResTeam();
      console.log('ResTeam :', ResTeam);
      //==============  FOR GET FROM API n8n =================
      //const ResTeam = state.reservationteam
      //console.log('ResAllTeam :',  JSON.stringify(state.reservationteam));
      //==============  END FOR GET FROM API n8n =================
      //console.log(localStorage.getItem('resteam'));
      // if (state.customerTeams == true) {
      //   //console.log('state.customerTeams :', state.customerTeams);
      //   customerTeam = 'a';
      // } else {
      //   //console.log('state.customerTeams :', state.customerTeams);
      //   customerTeam = 'b';
      // }
      //console.log('state.customerTeam', customerTeam);
      let customerTeam = state.customerTeams;
      // console.log('ResTeam :', state.reservationteam[customerTeam] );
      console.log('customerTeam', customerTeam);
      const data = {
        reservation: rootState.reservationId,
        ltime: new Date().getTime(),
        size: 20,
        tags: [],
        resMain: customerSelf
          ? String(rootState.reservationId) +
          (ResTeam[customerTeam] ? ',' + ResTeam[customerTeam] : '')
          : undefined, // -- ถ้าเป็น TEAM List ResID
        searchNotResponse: state.searchNotResponse,
      };

      const source = CancelToken.source();
      if (requests.length > 0) {
        for (const r of requests) {
          r.cancel();
        }
      }

      requests.splice(0);
      requests.push(source);

      const options = {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        data: data,
        url: API_CHAT + '/getlistcustomer',
        cancelToken: source.token,
      };

      const loadCustomer = new Promise(resolve => {
        axios(options)
          .then(function (response) {
            commit(
              'SET_LAST_CUSTOMER',
              response.data[response.data.length - 1],
            );
            commit('SOCKET_CUSTOMERS', response.data);
            console.log('Finish loadCustomer');
            resolve();
          })
          .catch(function (error) {
            console.log('error', error);
          });
      });
      console.log('Start loadCustomer');
      return await loadCustomer;
      // _socket.emit('listcustomer', rootState.reservationId, new Date());
    },
    loadMessages(
      { rootState, state, commit, dispatch },
      { custId, custName, time, type },
    ) {
      if (!_socket) {
        throw new Error("chat socket don't have connection");
      }
      if (!rootState.reservationId) {
        throw new Error('Reservation Id is invalid');
      }
      commit('LOADING', {
        stateName: 'messages',
        status: true,
      });
      // emit params????
      const data = {
        customerid: custId,
        customername: custName,
        size: 10,
        lasttime: time,
        resId: rootState.reservationId,
      };
      if (this.sourceLisHistory)
        this.sourceLisHistory.cancel('List history canceled');
      this.sourceLisHistory = CancelToken.source();
      const options = {
        method: 'POST',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: qs.stringify(data),
        url: API_CHAT + '/getlisthitory',
        cancelToken: this.sourceLisHistory.token,
      };
      return axios(options)
        .then(function (response) {
          let lastCustomerTime = 0;
          let isFb = false;
          for (const msg of response.data) {
            isFb = isNaN(msg.custId) == false;
            if (msg.sender === 'C' && msg.time > lastCustomerTime) {
              lastCustomerTime = msg.time;
            }
          }
          const timeDiff = Date.now() - lastCustomerTime;
          if (isFb && lastCustomerTime > 0 && 24 <= timeDiff / 1000 / 60 / 60) {
            commit('disableSendMessage', {
              value: true,
              reason:
                'ไม่สามารถส่งข้อความได้ เนื่องจากเกิน 24 ช.ม.\n\n**หากต้องการส่งข้อความ สามารถส่งผ่าน Page Mushroom Travel หรือรอจนกว่าลูกค้าส่งข้อความใหม่เข้ามา',
            });
          } else {
            commit('disableSendMessage', { value: false });
          }

          commit('SOCKET_MESSAGES', []);
          commit('SOCKET_MESSAGES', response.data);

          // Load pending messages from localStorage and merge
          // Only add if message truly doesn't exist on server (match by content + approximate time)
          var pendingMsgs = getPendingMessagesForCustomer(custId);
          if (pendingMsgs.length > 0) {
            pendingMsgs.forEach(function (msg) {
              // Check if message already exists by:
              // 1. Same temp messageid (localStorage was not cleaned)
              // 2. Same content and similar time (server has the real message)
              var exists = state.messages.find(function (m) {
                // Match by temp ID
                if (m.messageid === msg.messageid || m.messageId === msg.messageid) {
                  return true;
                }
                // Match by content and time (within 60 seconds)
                if (m.msg === msg.msg && Math.abs(m.time - msg.time) < 60000) {
                  return true;
                }
                return false;
              });
              if (exists) {
                // Server has the message, remove from localStorage
                removePendingMessage(custId, msg.messageid);
              } else {
                // Truly client-only, add to messages
                // Use ADD_LOCAL_MESSAGE to avoid updating customer list order
                commit('ADD_LOCAL_MESSAGE', {
                  ...msg,
                  isType: true,
                  sender: 'R',
                  resId: msg.resId || rootState.reservationId,
                  resNickname: msg.resNickname || msg.nickname || 'Me',
                  custName: msg.custName || 'Me',
                });
              }
            });
          }

          if (type == 'none') {
            commit('SOCKET_LAST_MESSSAGE', response.data[0]);
            commit(
              'SOCKET_First_MESSAGES',
              response.data[response.data.length - 1],
            );
          } else {
            commit(
              'SOCKET_First_MESSAGES',
              response.data[response.data.length - 1],
            );
          }
          // setTimeout(function() {
          commit('LOADING', {
            stateName: 'messages',
            status: false,
          });
          /*  $('.ps-container').scrollTop(999999999); */
          // }, 1000);
          commit('SET_LOAD_MORE', false);
        })
        .catch(function (error) {
          commit('SET_LOAD_MORE', false);
          console.log('error', error);
        });
    },
    sendMessage(
      { rootState, state, commit },
      { nickname, message, custName, type, suggestionId, eventRef },
    ) {
      if (!_socket) {
        throw new Error("chat socket don't have connection");
      }
      if (!rootState.reservationId) {
        throw new Error('Reservation Id is invalid');
      }

      // format message
      const matchUrl = message.match(/(^http.*\/)(.*)\n?/); // ของเดิมไม่ support การขึ้นบรรทัดใหม่หลังจาก link
      // m[1] + encodeURIComponent(m[2])
      // m[1] + m[2].replace(/ /g, '%20')
      if (matchUrl) {
        // http://192.168.17.149:8088/browse/ST-3010 เพิ่มการ replace ข้อความ แล้วเอามาต่อท้าย
        message =
          matchUrl[0].replace(/ /g, '%20') + message.replace(matchUrl[0], '');
      }

      // Verify mappingId belongs to the current customer.
      // If loadMessages hasn't resolved yet after a customer switch, lastMessage may be stale.
      const currentCustId = state.activeChatCustomer.custId;
      let mappingId = state.lastMessage && state.lastMessage.mappingId;
      if (state.lastMessage && state.lastMessage.custId != currentCustId) {
        // lastMessage is stale — try to get mappingId from current messages
        const fallback = state.messages.find(m => m.mappingId);
        if (fallback) {
          mappingId = fallback.mappingId;
        } else {
          // No valid mappingId for this customer — abort to prevent sending to wrong chatroom
          commit('messageReplying', null);
          commit('quoteMessageFocused', 'noquoted');
          throw new Error('Cannot send: chat history not loaded yet for this customer');
        }
      }

      // If messageReplying belongs to a different customer, cancel the reply.
      let quotedMessageId = '';
      let quotedMessageContent = '';
      let quotedMessageSender = '';
      if (state.messageReplying) {
        if (state.messageReplying.custId == currentCustId) {
          quotedMessageId = state.messageReplying.messageId;
          quotedMessageContent = state.messageReplying.msg;
          quotedMessageSender = state.messageReplying.custName;
        } else {
          // Stale reply from another customer — clear it
          commit('messageReplying', null);
          commit('quoteMessageFocused', 'noquoted');
        }
      }

      const time = new Date().getTime();
      const messageid = ('tmp' + Math.random() * 1000000).replace('.', '');

      commit('SOCKET_NEW_MESSAGE', {
        user: rootState.reservationId,
        text: message,
        name: nickname,
        custid: currentCustId,
        mappingId: mappingId,
        type: type,
        time: time,
        latestUpdated: new Date().toISOString(),
        firstMessageRead: true,
        custName: custName,
        isType: true,
        resId: rootState.reservationId,
        resNickname: '',
        sender: 'R',
        pushStatus: 'pending',
        pushError: null,
        pushAttempts: 0,
        ...(quotedMessageId
          ? {
            quotedMessageContent,
            quotedMessageSender,
            quotedMessageId,
          }
          : {}),
        messageid, // temporary
        quoteToken: 'temp_token',
      });

      commit('messageReplying', null);
      commit('quoteMessageFocused', 'noquoted');

      const data = {
        mappingId: mappingId,
        text: message,
        custid: currentCustId,
        customerSource: state.activeChatCustomer.customerSource,
        type: type,
        user: String(rootState.reservationId),
        name: nickname,
        quotedMessageId,
        suggestionId: suggestionId || '',
        eventRef: eventRef || '',
      };
      const options = {
        method: 'POST',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: qs.stringify(data),
        url: API_CHAT + '/setreservationmessage',
      };

      // Save to localStorage before API call (for client-side error recovery)
      var pendingMessageData = {
        messageid: messageid,
        msg: message,
        type: type,
        time: time,
        custId: currentCustId,
        mappingId: mappingId,
        custName: custName,
        resId: rootState.reservationId,
        resNickname: nickname,
        sender: 'R',
        isType: true,
        pushStatus: 'pending',
        pushError: null,
        pushAttempts: 0,
        nickname: nickname,
        customerSource: state.activeChatCustomer.customerSource,
        quotedMessageId: quotedMessageId,
        quotedMessageContent: quotedMessageContent,
        quotedMessageSender: quotedMessageSender,
      };
      savePendingMessage(currentCustId, pendingMessageData);

      axios(options)
        .then(function (response) {
          const { messageId, pushStatus, pushError, pushAttempts, _id: respId } = response.data;
          const chatHistoryId = (typeof respId === 'string' && /^[a-f0-9]{24}$/.test(respId)) ? respId : undefined;
          commit('patchMessageId', { oldId: messageid, newId: messageId, chatHistoryId });
          // Update message with backend response status
          commit('UPDATE_MESSAGE_PUSH_STATUS', {
            messageid: messageId || messageid,
            pushStatus: pushStatus || 'success',
            pushError: pushError || null,
            pushAttempts: pushAttempts || 0,
          });
          // Remove from localStorage on success
          removePendingMessage(pendingMessageData.custId, messageid);
          if (
            (response.statusText == 'OK' &&
              message.match(/http[s]?:\/\/.*([A-Z]{4}[0-9]{6})/)) ||
            message.match(/[0-9]{6}\.pdf/)
          ) {
            if (message.match(/[0-9]{6}\.pdf/)) {
              let obj = {
                ref: message.match(/[0-9]{6}\.pdf/)[0].replace('.pdf', ''),
                custId: state.activeChatCustomer.custId,
              };
              commit('SET_LIST_REFBOOKING', obj);
            } else {
              if (message.match(/http[s]?:\/\/.*([A-Z]{4}[0-9]{6})/)) {
                let msg = message.match(/http[s]?:\/\/.*([A-Z]{4}[0-9]{6})/)[0];

                let obj = {
                  ref: msg.split(msg.match(/http[s]?:\/\/.*([A-Z]{4})/)[0])[1],
                  custId: state.activeChatCustomer.custId,
                };
                commit('SET_LIST_REFBOOKING', obj);
              }
            }
          }
        })
        .catch(function (error) {
          // Update to failed status with error message
          var errorMsg = (error.response && error.response.data && error.response.data.message) || error.message || 'Network error';
          commit('UPDATE_MESSAGE_PUSH_STATUS', {
            messageid: messageid,
            pushStatus: 'failed',
            pushError: errorMsg,
            pushAttempts: 1,
          });
          // Update localStorage with failed status (for persistence after reload)
          // isClientError flag indicates this never reached server (network error)
          savePendingMessage(pendingMessageData.custId, {
            ...pendingMessageData,
            pushStatus: 'failed',
            pushError: errorMsg,
            pushAttempts: 1,
            isClientError: true,
          });
          console.log('error', error);
        });
    },
    searchMessage({ state, rootState, commit }, text) {
      if (!_socket) {
        throw new Error("chat socket don't have connection");
      }
      if (!rootState.reservationId) {
        throw new Error('Reservation Id is invalid');
      }
      const param = {
        data: text,
        // resid: rootState.reservationId,
        type: 'chat',
      };

      if (state.customerSelf) {
        param.resid = rootState.reservationId;
      }

      const options = {
        method: 'POST',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: qs.stringify(param),
        url: API_CHAT + '/searchchat',
      };
      axios(options)
        .then(function (response) {
          commit('SOCKET_SEARCH_MESSAGES', response.data);
        })
        .catch(function (error) {
          console.log('error', error);
        });
    },
    searchContact({ state, rootState, commit }, text) {
      if (!_socket) {
        throw new Error("chat socket don't have connection");
      }
      if (!rootState.reservationId) {
        throw new Error('Reservation Id is invalid');
      }
      const ResTeam = fnLoadResTeam();
      //==============  FOR GET FROM API n8n =================
      //const ResTeam = state.reservationteam
      //==============  FOR GET FROM API n8n =================
      console.log('ResTeam', ResTeam);
      // if (state.customerTeams == true) {
      //   //console.log('state.customerTeams :', state.customerTeams);
      //   customerTeam = 'a';
      // } else {
      //   //console.log('state.customerTeams :', state.customerTeams);
      //   customerTeam = 'b';
      // }
      let customerTeam = state.customerTeams;
      const param = {
        data: text,
        resid: rootState.reservationId,
        type: 'contact',
        resMain: state.customerSelf
          ? String(rootState.reservationId) +
          (ResTeam[customerTeam] ? ',' + ResTeam[customerTeam] : '')
          : undefined, // -- ถ้าเป็น TEAM List ResID
        // resMain: state.customerSelf
        //   ? String(rootState.reservationId)
        //   : undefined,
        searchNotResponse: state.searchNotResponse,
      };
      const options = {
        method: 'POST',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: qs.stringify(param),
        url: API_CHAT + '/searchcontact',
      };
      axios(options)
        .then(function (response) {
          commit('SOCKET_CUSTOMERS', response.data);
          commit('SET_LAST_CUSTOMER', response.data[response.data.length - 1]);
        })
        .catch(function (error) {
          console.log('error', error);
        });
    },
    searchContactForActive({ dispatch, rootState, commit }, text) {
      if (!_socket) {
        throw new Error("chat socket don't have connection");
      }
      if (!rootState.reservationId) {
        throw new Error('Reservation Id is invalid');
      }
      const param = {
        data: text,
        resid: rootState.reservationId,
        type: 'contact',
      };
      const options = {
        method: 'POST',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: qs.stringify(param),
        url: API_CHAT + '/searchcontact',
      };
      axios(options)
        .then(function (response) {
          commit('SOCKET_CUSTOMERS', response.data);
          commit('SET_LAST_CUSTOMER', response.data[response.data.length - 1]);
          dispatch('setActiveChatCustumer', response.data[0]);
          rootState.cusIdActive = null;
        })
        .catch(function (error) {
          console.log('error', error);
        });
    },
    searchContactFromBooking({ dispatch, rootState, commit }, text) {
      if (!_socket) {
        throw new Error("chat socket don't have connection");
      }
      if (!rootState.reservationId) {
        throw new Error('Reservation Id is invalid');
      }
      const param = {
        customerId: text
      };
      console.log('param : ' + JSON.stringify(param));
      const options = {
        method: 'GET',
        //headers: { 'content-type': 'application/x-www-form-urlencoded' },
        //data: qs.stringify(param),
        url: API_CHAT + '/lastCustomerMessage?customerId=' + text,
      };
      axios(options)
        .then(function (response) {
          console.log('response : ' + JSON.stringify(response.data));
          //commit('SOCKET_CUSTOMERS', JSON.stringify(response.data));
          commit('SET_LAST_CUSTOMER', response.data);
          dispatch('setActiveChatCustumer', response.data);
          //rootState.cusIdActive = null;
        })
        .catch(function (error) {
          console.log('error', error);
        });
    },
    setActiveChatCustumer({ commit, dispatch }, customer) {
      if (
        customer &&
        customer.refCode == undefined &&
        customer.bookingId == undefined
      ) {
        customer.refCode = [];
        customer.bookingId = 0;
      }
      dispatch('checkProfileAndName', customer);
    },
    checkProfileAndName({ commit, dispatch }, customer) {
      if (customer == null) {
        commit('SET_ACTIVE_CHAT_CUSTUMER', customer);
      } else {
        if (
          customer.custImage == null ||
          customer.custName == null ||
          customer.custName == ''
        ) {
          dispatch('fnGetImageProfileCus', customer);
        } else {
          fetch(customer.custImage)
            .then(response => {
              if (
                response.status == 404 &&
                response.statusText == 'Not Found'
              ) {
                dispatch('fnGetImageProfileCus', customer);
              } else {
                commit('SET_ACTIVE_CHAT_CUSTUMER', customer);
              }
            })
            .catch(error => {
              dispatch('fnGetImageProfileCus', customer);
            });
        }
      }
    },
    fnGetImageProfileCus({ commit }, customer) {
      const options = {
        method: 'GET',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        url: API_CHAT + '/synccustomerprofile/' + customer.custId,
      };
      axios(options)
        .then(function (response) {
          if (response.status == 404 && response.statusText == 'Not Found') {
            customer.custImage =
              'https://mushbot-static.softsq.com/mushroom_logo.jpg';
          } else {
            customer.custName = response.data.displayName;
            customer.custImage = response.data.pictureUrl;
          }
          commit('SET_ACTIVE_CHAT_CUSTUMER', customer);
        })
        .catch(function (error) {
          console.log('error', error);
          customer.custImage =
            'https://mushbot-static.softsq.com/mushroom_logo.jpg';
          commit('SET_ACTIVE_CHAT_CUSTUMER', customer);
        });
    },
    clearSearchMessage({ commit }) {
      commit('SOCKET_SEARCH_MESSAGES', []);
    },
    clearSearchContact({ commit }) {
      commit('API_SEARCH_CONTACT', null);
    },
    clearCustomer({ state, commit }) {
      if (state.customers.length > 0 && state.activeChatCustomer != null) {
        if (state.customers[state.activeChatCustomer.custId]) {
          commit('SET_ACTIVE_CHAT_CUSTUMER', null);
        }
      }
    },
    saveContactCustumer({ commit }, cust) {
      if (!_socket) {
        throw new Error("chat socket don't have connection");
      }
      const params = {
        customerid: cust.custId,
        displayname: cust.custName,
      };
      commit('UPDATE_NAME_CUSTUMER', params);
      const options = {
        method: 'POST',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: qs.stringify(params),
        url: API_CHAT + '/seteditdisplayname',
      };
      axios(options)
        .then(function (response) {
          console.log('response setNameCustomer>>>', response.data);
        })
        .catch(function (error) {
          console.log('error', error);
        });
      // _socket.emit('editdisplayname', params);
    },
    sendReadMessage({ rootState, state }, messageId) {
      _socket.emit('updatemessage', {
        messageId,
        customerId: state.activeChatCustomer.custId,
        reservationId: rootState.reservationId,
      });
    },
    async loadQuickReplyTemplates({ commit, rootState }, { forceRefresh } = {}) {
      if (!forceRefresh) {
        const cached = getCachedQuickReplyTemplates();
        if (cached) {
          commit('SET_QUICK_REPLY_TEMPLATES', cached);
          return;
        }
      }
      commit('SET_QUICK_REPLY_LOADING', true);
      try {
        const res = await apiChat.get('/quick-reply/templates', {
          params: { reservationId: rootState.reservationId },
        });
        if (res.data && res.data.success) {
          const { templates, reservationTemplates } = res.data.data;
          const merged = mergeQuickReplyTemplates(templates, reservationTemplates);
          cacheQuickReplyTemplates(merged);
          commit('SET_QUICK_REPLY_TEMPLATES', merged);
        } else {
          const cached = getCachedQuickReplyTemplates();
          commit('SET_QUICK_REPLY_TEMPLATES', cached || defaultQuickReplyTemplates);
        }
      } catch (e) {
        console.error('loadQuickReplyTemplates error:', e);
        const cached = getCachedQuickReplyTemplates();
        commit('SET_QUICK_REPLY_TEMPLATES', cached || defaultQuickReplyTemplates);
      } finally {
        commit('SET_QUICK_REPLY_LOADING', false);
      }
    },
    toggleQuickReplyExpanded({ commit }, code) {
      commit('SET_QUICK_REPLY_EXPANDED', code);
    },
    loadMoreMessage(
      { commit, rootState, state },
      { custId, custName, time, type, noScroll },
    ) {
      if (type == 'scroll') {
        const data = {
          customerid: custId,
          customername: custName,
          size: 8,
          lasttime: time,
          resId: rootState.reservationId,
        };
        // console.log('data', data);
        const options = {
          method: 'POST',
          headers: { 'content-type': 'application/x-www-form-urlencoded' },
          data: qs.stringify(data),
          url: API_CHAT + '/getlisthitory',
          cancelToken: this.sourceLisHistory.token,
        };
        axios(options)
          .then(function (response) {
            const messageMap = response.data.map(fnSetMessageModel);
            commit('SOCKET_SET_MOREMES', messageMap);
            commit(
              'SOCKET_First_MESSAGES',
              response.data[response.data.length - 1],
            );
            setTimeout(function () {
              commit('SET_LOAD_MORE', false);
              if (!noScroll) {
                $('.ChatBox__List').animate(
                  {
                    scrollTop: 700,
                  },
                  200,
                );
              }
            }, 500);
          })
          .catch(function (error) {
            console.log('error', error);
          });
      }
    },
    async toQuotedMessage({ commit, state, rootState, dispatch }, targetId) {
      const chatList = document.querySelector('.ChatBox__List');
      if (!chatList) {
        return;
      }
      // Resolve targetId to LINE messageId (DOM uses msg-${messageId})
      // targetId may be MongoDB _id (from suggestion chatHistoryId) or LINE messageId
      let domId = targetId;
      const stateMsg = state.messages.find(m => m.chatHistoryId === targetId || m._id === targetId || m.messageId === targetId);
      if (stateMsg && stateMsg.messageId) {
        domId = stateMsg.messageId;
      }

      const msg = chatList.querySelector(`#msg-${domId}`);
      if (msg) {
        commit('quoteMessageFocused', domId);
        msg.scrollIntoView();
        setTimeout(() => {
          commit('quoteMessageFocused', 'noquoted');
        }, 2000);
        return;
      }
      if (!state.firstMessage) {
        Message({
          message: 'ไม่พบข้อความที่ต้องการ',
          type: 'error',
          duration: 2000,
        });
        return;
      }
      const loadMoreLimit = 9;
      let loadTime = 1;
      let msgMore = null;
      let cancelled = false;

      const loading = Loading.service({
        text: 'กำลังโหลดข้อความ... (1/' + loadMoreLimit + ')',
        background: 'rgba(0, 0, 0, 0.7)',
        customClass: 'jump-message-loading',
      });

      // Add cancel button inside spinner for proper centering
      setTimeout(() => {
        const spinnerEl = document.querySelector('.jump-message-loading .el-loading-spinner');
        if (spinnerEl) {
          const cancelBtn = document.createElement('button');
          cancelBtn.textContent = 'ยกเลิก';
          cancelBtn.style.cssText = 'margin-top:16px;padding:8px 24px;border:1px solid #fff;border-radius:6px;background:transparent;color:#fff;font-size:14px;cursor:pointer;display:block;margin-left:auto;margin-right:auto;';
          cancelBtn.onmouseenter = () => { cancelBtn.style.background = 'rgba(255,255,255,0.15)'; };
          cancelBtn.onmouseleave = () => { cancelBtn.style.background = 'transparent'; };
          cancelBtn.onclick = () => { cancelled = true; loading.close(); };
          spinnerEl.appendChild(cancelBtn);
        }
      }, 0);

      while (loadTime <= loadMoreLimit && !msgMore && !cancelled) {
        if (!state.firstMessage) break;
        await dispatch('loadMoreMessage', {
          custId: state.firstMessage.custId,
          custName: state.firstMessage.custName,
          time: state.firstMessage.time,
          type: 'scroll',
          noScroll: true,
        });

        await delay(200);
        // After loading more, resolve domId again (message may now be in state)
        if (domId === targetId) {
          const newMsg = state.messages.find(m => m._id === targetId || m.messageId === targetId);
          if (newMsg && newMsg.messageId) {
            domId = newMsg.messageId;
          }
        }
        msgMore = chatList.querySelector(`#msg-${domId}`);
        console.log('load time', [loadTime, msgMore]);
        loadTime += 1;

        // Update loading text with progress
        const spinnerText = loading.$el ? loading.$el.querySelector('.el-loading-text') : null;
        if (spinnerText) {
          spinnerText.textContent = 'กำลังโหลดข้อความ... (' + loadTime + '/' + loadMoreLimit + ')';
        }
      }
      if (!cancelled) loading.close();
      if (msgMore) {
        commit('quoteMessageFocused', domId);
        msgMore.scrollIntoView();
        setTimeout(() => {
          commit('quoteMessageFocused', 'noquoted');
        }, 2000);
      } else if (!cancelled) {
        Message({
          message: 'ไม่พบข้อความที่ต้องการ',
          type: 'error',
          duration: 2000,
        });
      }
    },
    loadMoreCustomer({ commit, state, rootState }, terms) {
      commit('LOADING', {
        stateName: 'customersLoadMore',
        status: true,
      });

      const ResTeam = fnLoadResTeam();
      //==============  FOR GET FROM API n8n =================
      //const ResTeam = state.reservationteam
      //==============  END FOR GET FROM API n8n =================
      console.log('ResTeam', ResTeam);
      // if (state.customerTeams == true) {
      //   //console.log('state.customerTeams :', state.customerTeams);
      //   customerTeam = 'a';
      // } else {
      //   //console.log('state.customerTeams :', state.customerTeams);
      //   customerTeam = 'b';
      // }
      let customerTeam = state.customerTeams;
      const data = {
        reservation: rootState.reservationId,
        lastCustomer: state.lastCustomer,
        size: 20,
        terms,
        resMain: state.customerSelf
          ? String(rootState.reservationId) +
          (ResTeam[customerTeam] ? ',' + ResTeam[customerTeam] : '')
          : undefined, // -- ถ้าเป็น TEAM List ResID
        // resMain: state.customerSelf
        //   ? String(rootState.reservationId)
        //   : undefined,
        searchNotResponse: state.searchNotResponse,
      };
      fetch(`${API_CHAT}/getlistcustomer`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then(result => result.json())
        .then(response => {
          if (response.length > 0) {
            commit('SET_LAST_CUSTOMER', response[response.length - 1]);
            commit('API_SET_MORECUS', response);
          } else {
            commit('LOADING', {
              stateName: 'customersLoadMore',
              status: false,
            });
          }
        })
        .catch(function (error) {
          console.log('error', error);
        });
    },
    checkScrollTop({ commit }, scroll) {
      commit('SCROLL_SATUSE', scroll);
    },
    setMessageNew({ commit }, messages) {
      commit('MESSAGE_SCROLL', messages);
    },
    searchProduct({ commit, state, rootState }, code) {
      commit('API_SEARCH_PRODUCT', null);
      commit('SET_PERIOD_PRODUCT', null);
      commit('SET_PRODUCT_LOADING', true);
      axios
        .get(API_SEARHPRODUCT + '/products/ProductChatApp', {
          params: {
            productCode: 'mush' + code,
          },
          headers: {
            'content-type': 'application/json',
            token: window.sessionStorage.getItem('token'),
          },
        })
        .then(function (response) {
          if (response.data != null) {
            forEach(response.data.period, function (val) {
              val.mouthCode = val.period_start.split(' ')[1];
              val.dayCode = val.period_start.split(' ')[0];
            });
            commit('API_SEARCH_PRODUCT', response.data);
          } else {
            commit('API_SEARCH_PRODUCT', null);
          }
        })
        .catch(function (error) {
          console.log('error', error);
        });
    },
    async searchBookingLead({ commit }, socialId) {
      try {
        const result = await axios
          .get(API_MUSH + '/Contact/LeadMainbookingIdFromSocialId', {
            params: {
              token: localStorage.getItem('token'),
              socialId,
            },
          })
          .then(r => r.data);
        if (result) {
          commit('SET_BOOKING_CUSTOMER', result.mainBookingId * -1);
        }
        return result;
      } catch (err) {
        console.log(err);
      }
      return null;
    },
    clearProductSearch({ commit, state }) {
      commit('API_SEARCH_PRODUCT', null);
    },
    clearPeriodProduct({ commit, state }) {
      commit('SET_PERIOD_PRODUCT', null);
    },
    setPeriodProductSearch({ commit, state }, periods) {
      if (state.productDetail && periods.length > 0) {
        const dataPeriods = [];
        var mapDataPeriod = '';
        var product_slug =
          'https://www.mushroomtravel.com/tour/outbound/' +
          state.productDetail.country_slug +
          '/' +
          state.productDetail.product_code.toLowerCase() +
          '-' +
          state.productDetail.product_slug;

        forEach(periods, function ($data) {
          const n = filter(state.productDetail.period, function (val) {
            return $data == val.period_id;
          });
          dataPeriods.push(n[0]);
        });
        if (state.numPeriods.length > 20) {
          commit(
            'SET_PERIOD_PRODUCT',
            'ดูรายละเอียดเพิ่มได้ที่ >>>' + product_slug,
          );
        } else {
          forEach(dataPeriods, function (v) {
            commit('SET_NUM_PERIODS', v);

            if (state.numPeriods.length <= 20) {
              let discountAmount = 0;
              if (v.is_promotion && state.productDetail.promotion_discount_periods) {
                const periodStartDate = new Date(v.period_start_value);
                const matchingPeriod = state.productDetail.promotion_discount_periods.find(
                  period => {
                    const departureStart = new Date(period.departure_start + 'T00:00:00');
                    const departureEnd = new Date(period.departure_end + 'T00:00:00');
                    return periodStartDate >= departureStart && periodStartDate <= departureEnd;
                  }
                );
                if (matchingPeriod) {
                  discountAmount = matchingPeriod.discount;
                }
              }

              mapDataPeriod +=
                (v.is_promotion ? '🔖' : '▶️') +
                fnSetPeriodDate(v.period_start) +
                '-' +
                fnSetPeriodDate(v.period_end) +
                ' ว่าง' +
                String(v.seat_update).padStart(2, '0') +
                'ที่ ' +
                (v.is_promotion && discountAmount > 0
                  ? `${fnsetFormatPrice(
                    v.price_adults_double.toString(),
                  )} หรือลด${fnsetFormatPrice(
                    discountAmount.toString(),
                  )}`
                  : (v.price_adults_double_from &&
                    v.price_adults_double_from > v.price_adults_double
                      ? fnsetFormatPrice(
                          v.price_adults_double_from.toString(),
                        ) + ' เหลือ'
                      : '') +
                    fnsetFormatPrice(v.price_adults_double.toString())) +
                fnFormatAllotWarning(v.allot_date) +
                '\n';
            }
          });
          commit('SET_PERIOD_PRODUCT', mapDataPeriod);
        }
      } else {
        commit('SET_PERIOD_PRODUCT', null);
      }
    },
    openAdatForBooking({ commit, state }, customer) {
      // console.log('openAdatForBooking mobile:', customer)
      //console.log('window.parent.location :', window.location. )
      //  window.parent.location
      //  if (!state.isMobileMode) {
      //  window.parent.postMessage({ OpenAdat: customer }, '*');
      // } else {
      //   console.log('openAdatForBooking mobile:', iframe)

      // }
      var iframe = document.getElementById('grid1');
      console.log('openAdatForBooking iframe:', iframe);
      iframe = iframe ? iframe.contentWindow : null;

      console.log('contentWindow mobile:', iframe);
      iframe.postMessage({ OpenAdat: customer }, '*');
    },
    openBooking({ commit, state }, bookingId) {
      console.log('openBooking : isMobileMode ', state.isMobileMode);
      if (!state.isMobileMode) {
        //console.log('openBooking :  ', !state.isMobileMode)
        //window.parent.postMessage({ OpenBookingFromChat: bookingId }, '*');

        var iframe = document.getElementById('grid1');
        console.log('openAdatForBooking iframe:', iframe);
        iframe = iframe ? iframe.contentWindow : null;

        console.log('contentWindow mobile:', iframe);
        iframe.postMessage({ OpenBookingFromChat: bookingId }, '*');
      } else {
        window.open(Root + 'Booking/Main.aspx?id=' + bookingId, '_blank');
      }
    },
    searchlineIdforRef({ commit }, custId) {
      const CancelToken = axios.CancelToken;
      let cancel;
      const promise = Request.get(
        API_CHAT + '/history/productcodetocustomer/' + custId,
        {
          cancelToken: new CancelToken(function executor(c) {
            cancel = c;
          }),
        },
      );
      promise
        .then(({ data: productCode }) => {
          if (productCode && productCode.length > 0) {
            const mushCode = uniq(
              productCode.map(v => {
                return v.productCode;
              }),
            );
            commit('API_SET_CODE', mushCode);
          } else {
            commit('API_SET_CODE', []);
          }
        })
        .catch(function (error) {
          console.log('error', error);
        });
      return { request: promise, cancel };
    },
    async loadCheckBooking({ dispatch, commit }, custId) {
      const CancelToken = axios.CancelToken;
      let cancel;
      const promise = apiChat.get('/getBookingFromLine/' + custId, {
        cancelToken: new CancelToken(function executor(c) {
          cancel = c;
        }),
      });
      promise
        .then(async ({ data: booking }) => {
          if (booking && booking.length > 0 && booking[0].bookingId > 0) {
            commit('SET_BOOKING_CUSTOMER', booking[0].bookingId);
          } else {
            commit('SET_BOOKING_CUSTOMER', 0);
            await dispatch('searchlineIdforRef', custId).then(
              ({ request, cel }) => {
                cancel = cel;
              },
            );
          }
        })
        .catch(function (error) {
          console.log('error', error);
          commit('SET_LOADING_REF', false);
        });

      return { request: promise, cancel };
    },
    async resendMessage({ commit, state, rootState }, data) {
      var messageId = data.messageId || data.messageid;
      // MongoDB _id is needed for retry endpoint (backend uses findById)
      var mongoId = data._id;

      if ((!messageId && !mongoId) || !state.messages || state.messages.length === 0) {
        return { request: 'error', error: 'Invalid message' };
      }

      // Check if this is a client-only failed message (never reached server)
      // Client errors: isClientError === true OR has temp ID (starts with 'tmp') OR no MongoDB _id
      var isClientOnly = data.isClientError === true ||
        (messageId && messageId.toString().indexOf('tmp') === 0) ||
        !mongoId;

      console.log('[resendMessage] messageId:', messageId, 'mongoId:', mongoId, 'isClientError:', data.isClientError, 'isClientOnly:', isClientOnly);

      // Set to pending while retrying
      commit('UPDATE_MESSAGE_PUSH_STATUS', {
        messageid: messageId,
        pushStatus: 'pending',
        pushError: null,
        pushAttempts: data.pushAttempts || 0,
      });

      if (isClientOnly) {
        // Re-send using original sendMessage flow (message never reached server)
        var sendData = {
          mappingId: data.mappingId || state.lastMessage.mappingId,
          text: data.msg,
          custid: data.custId || state.activeChatCustomer.custId,
          customerSource: data.customerSource || state.activeChatCustomer.customerSource,
          type: data.type || 'string',
          user: String(rootState.reservationId),
          name: data.nickname || data.custName,
          quotedMessageId: data.quotedMessageId || '',
        };
        var options = {
          method: 'POST',
          headers: { 'content-type': 'application/x-www-form-urlencoded' },
          data: qs.stringify(sendData),
          url: API_CHAT + '/setreservationmessage',
        };

        try {
          var response = await axios(options);
          var responseMessageId = response.data.messageId;
          var pushStatus = response.data.pushStatus;
          var pushError = response.data.pushError;
          var pushAttempts = response.data.pushAttempts;
          var respId = response.data._id;
          var retryChatHistoryId = (typeof respId === 'string' && /^[a-f0-9]{24}$/.test(respId)) ? respId : undefined;

          // Patch the message ID and update status
          commit('patchMessageId', { oldId: messageId, newId: responseMessageId, chatHistoryId: retryChatHistoryId });
          commit('UPDATE_MESSAGE_PUSH_STATUS', {
            messageid: responseMessageId || messageId,
            pushStatus: pushStatus || 'success',
            pushError: pushError || null,
            pushAttempts: pushAttempts || (data.pushAttempts || 0) + 1,
          });

          // Remove from localStorage on success
          var custIdForUpdate = data.custId || state.activeChatCustomer.custId;
          removePendingMessage(custIdForUpdate, messageId);

          // Update customer error status if success
          if (pushStatus === 'success' && custIdForUpdate) {
            var remainingFailed = state.messages.filter(function (m) {
              return m.pushStatus === 'failed' && m.sender === 'R';
            }).length;
            var localPending = getPendingMessagesForCustomer(custIdForUpdate);
            var localFailedCount = localPending.filter(function (m) {
              return m.pushStatus === 'failed';
            }).length;
            var totalFailed = remainingFailed + localFailedCount;
            commit('UPDATE_CUSTOMER_ERROR_STATUS', {
              custId: custIdForUpdate,
              hasFailedMessages: totalFailed > 0,
              failedMessageCount: totalFailed,
              latestMsg: data.msg,
            });
          }

          return { request: pushStatus === 'success' ? 'success' : 'failed', error: pushError };
        } catch (error) {
          var errorMsg = (error.response && error.response.data && error.response.data.message) || error.message || 'Retry failed';
          commit('UPDATE_MESSAGE_PUSH_STATUS', {
            messageid: messageId,
            pushStatus: 'failed',
            pushError: errorMsg,
            pushAttempts: (data.pushAttempts || 0) + 1,
          });
          // Update localStorage with new error (preserve isClientError flag)
          savePendingMessage(data.custId || state.activeChatCustomer.custId, {
            ...data,
            pushStatus: 'failed',
            pushError: errorMsg,
            pushAttempts: (data.pushAttempts || 0) + 1,
            isClientError: true,
          });
          return { request: 'error', error: errorMsg };
        }
      } else {
        // Use retry endpoint for server-failed messages (use MongoDB _id)
        try {
          var retryResponse = await axios.post(API_CHAT + '/retry-message/' + mongoId);
          var retryPushStatus = retryResponse.data.pushStatus;
          var retryPushAttempts = retryResponse.data.pushAttempts;
          var updatedMessage = retryResponse.data.message;
          // pushError is inside the message object from backend
          var retryPushError = (updatedMessage && updatedMessage.pushError) || null;

          commit('UPDATE_MESSAGE_PUSH_STATUS', {
            messageid: messageId,
            pushStatus: retryPushStatus || 'success',
            pushError: retryPushError,
            pushAttempts: retryPushAttempts || (data.pushAttempts || 0) + 1,
          });

          // Update customer error status if success
          var retryCustId = data.custId || (state.activeChatCustomer && state.activeChatCustomer.custId);
          if (retryPushStatus === 'success' && retryCustId) {
            var retryRemainingFailed = state.messages.filter(function (m) {
              return m.pushStatus === 'failed' && m.sender === 'R';
            }).length;
            var retryLocalPending = getPendingMessagesForCustomer(retryCustId);
            var retryLocalFailedCount = retryLocalPending.filter(function (m) {
              return m.pushStatus === 'failed';
            }).length;
            var retryTotalFailed = retryRemainingFailed + retryLocalFailedCount;
            commit('UPDATE_CUSTOMER_ERROR_STATUS', {
              custId: retryCustId,
              hasFailedMessages: retryTotalFailed > 0,
              failedMessageCount: retryTotalFailed,
              latestMsg: data.msg,
            });
          }

          return { request: retryPushStatus === 'success' ? 'success' : 'failed', error: retryPushError };
        } catch (error) {
          // Backend error response uses 'error' field, not 'message'
          var retryErrorMsg = (error.response && error.response.data && error.response.data.error) || error.message || 'Retry failed';
          commit('UPDATE_MESSAGE_PUSH_STATUS', {
            messageid: messageId,
            pushStatus: 'failed',
            pushError: retryErrorMsg,
            pushAttempts: (data.pushAttempts || 0) + 1,
          });
          return { request: 'error', error: retryErrorMsg };
        }
      }
    },
    async removeFailedMessage({ commit, state }, data) {
      var messageId = data.messageId || data.messageid;
      var mongoId = data._id;
      var custId = data.custId || (state.activeChatCustomer && state.activeChatCustomer.custId);

      // If server-side message (has MongoDB _id), call API to delete
      if (mongoId) {
        try {
          await axios.delete(API_CHAT + '/remove-failed-message/' + mongoId);
        } catch (error) {
          console.error('[removeFailedMessage] API error:', error);
          // Continue to remove from UI even if API fails
        }
      }

      // Remove from Vuex state
      commit('REMOVE_MESSAGE', messageId);

      // Remove from localStorage if exists (client-only messages)
      if (custId && messageId) {
        removePendingMessage(custId, messageId);
      }

      // Recalculate and update customer error status
      if (custId) {
        // Count remaining failed messages in state
        var remainingFailed = state.messages.filter(function (m) {
          return m.pushStatus === 'failed' && m.sender === 'R';
        }).length;

        // Also count localStorage failed messages
        var localPending = getPendingMessagesForCustomer(custId);
        var localFailedCount = localPending.filter(function (m) {
          return m.pushStatus === 'failed';
        }).length;

        var totalFailed = remainingFailed + localFailedCount;

        commit('UPDATE_CUSTOMER_ERROR_STATUS', {
          custId: custId,
          hasFailedMessages: totalFailed > 0,
          failedMessageCount: totalFailed,
        });
      }
    },
    enableEditMessage({ commit }, token) {
      if (token !== 'mushadmin') {
        return false;
      }
      commit('SET_EDIT_MESSAGE_ENABLED', true);
      try { sessionStorage.setItem('editMessageToken', 'mushadmin'); } catch (e) { /* sessionStorage unavailable */ }
      return true;
    },
    disableEditMessage({ commit }) {
      commit('SET_EDIT_MESSAGE_ENABLED', false);
      try { sessionStorage.removeItem('editMessageToken'); } catch (e) { /* sessionStorage unavailable */ }
    },
    restoreEditMessageFlag({ commit }) {
      try {
        if (sessionStorage.getItem('editMessageToken') === 'mushadmin') {
          commit('SET_EDIT_MESSAGE_ENABLED', true);
        }
      } catch (e) { /* sessionStorage unavailable */ }
    },
    // Edit a customer-side chat row.
    // payload: { chatHistoryId, messageId, mode, newText, file }
    //   - mode === 'text' → PUT  /chathistoryui/:id/text   body { message }
    //   - mode === 'file' → POST /chathistoryui/:id/file   multipart { file }
    // Response shape: { success, data: { ...full row, message, type, modifiedDate } }
    // Backend enforces sender === 'C'; frontend gates the affordance the same way.
    async editCustomerMessage({ commit }, payload) {
      const { chatHistoryId, messageId, mode, newText, file } = payload || {};
      if (!chatHistoryId) {
        return { success: false, error: 'missing chatHistoryId' };
      }
      try {
        let response;
        if (mode === 'file' && file) {
          if (file.size > 100 * 1024 * 1024) {
            return { success: false, error: 'ไฟล์มีขนาดใหญ่เกิน 100 MB' };
          }
          const form = new FormData();
          form.append('file', file);
          response = await apiChat.post(
            '/chathistoryui/' + chatHistoryId + '/file',
            form,
          );
        } else {
          const trimmed = (newText || '').trim();
          if (!trimmed) {
            return { success: false, error: 'กรุณาพิมพ์ข้อความ' };
          }
          response = await apiChat.put(
            '/chathistoryui/' + chatHistoryId + '/text',
            { message: trimmed },
          );
        }
        const body = (response && response.data) || {};
        if (!body.success) {
          return { success: false, error: body.message || 'บันทึกไม่สำเร็จ' };
        }
        const row = body.data || {};
        commit('PATCH_MESSAGE_CONTENT', {
          chatHistoryId,
          messageId,
          msg: row.message !== undefined ? row.message : (mode === 'file' ? '' : newText),
          type: row.type || (mode === 'file' ? 'file' : 'string'),
        });
        return { success: true, data: row };
      } catch (error) {
        console.error('[editCustomerMessage] API error:', error);
        const body = error && error.response && error.response.data;
        const errMsg = (body && body.message)
          || (error && error.message)
          || 'แก้ไขข้อความไม่สำเร็จ';
        return { success: false, error: errMsg };
      }
    },
    setLoadMore({ commit, state }, data) {
      commit('SET_LOAD_MORE', data);
    },
    setTypeChat({ commit }, data) {
      commit('SET_TYPE_CHAT', data);
    },
    loadSickerandfile({ commit, state }, type) {
      const options = {
        method: 'GET',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        url: API_CHAT + '/getContentTemplate',
      };
      var _promiseLoadSticker = new Promise(resolve => {
        axios(options)
          .then(function (response) {
            if (response.status == 200 && response.data != null) {
              commit('SET_STICKERS_AND_OFTENIMAGE', response.data);
              resolve(response.data);
            }
          })
          .catch(function (error) {
            console.log('error', error);
          });
      });
      return _promiseLoadSticker;
    },
    loadCusForTags({ rootState, commit, state }, tags) {
      if (!_socket) {
        throw new Error("chat socket don't have connection");
      }
      if (!rootState.reservationId) {
        throw new Error('Reservation Id is invalid');
      }
      console.log('tags', tags);
      const ResTeam = fnLoadResTeam();
      //==============  FOR GET FROM API n8n =================
      //const ResTeam = state.reservationteam;//rootState.reservationteam
      //==============  END FOR GET FROM API n8n =================
      console.log('ResTeam', ResTeam);
      // if (state.customerTeams == true) {
      //   //console.log('state.customerTeams :', state.customerTeams);
      //   customerTeam = 'a';
      // } else {
      //   //console.log('state.customerTeams :', state.customerTeams);
      //   customerTeam = 'b';
      // }
      let customerTeam = rootState.customerTeams;
      const data = {
        reservation: rootState.reservationId,
        resMain: rootState.customerSelf
          ? String(rootState.reservationId) +
          (ResTeam[customerTeam] ? ',' + ResTeam[customerTeam] : '')
          : undefined,
        ltime: new Date().getTime(),
        size: 20,
        tags: tags,
        searchNotResponse: state.searchNotResponse,
      };
      const options = {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        data: data,
        url: API_CHAT + '/getlistcustomer',
      };
      var _promiseLoadCustomer = new Promise(resolve => {
        axios(options)
          .then(function (response) {
            commit(
              'SET_LAST_CUSTOMER',
              response.data[response.data.length - 1],
            );
            const param = {
              data: response.data,
              tags: tags,
            };
            commit('SET_CUSTOMER_SEARCHTAG', param);
            resolve();
          })
          .catch(function (error) {
            console.log('error', error);
          });
      });
      return _promiseLoadCustomer;
    },
    loadMoreCustomerForTags({ commit, state, rootState }, tags) {
      commit('LOADING', {
        stateName: 'customersLoadMore',
        status: true,
      });
      const data = {
        reservation: rootState.reservationId,
        lastCustomer: state.lastCustomer,
        size: 20,
        tags,
        searchNotResponse: state.searchNotResponse,
      };
      fetch(`${API_CHAT}/getlistcustomer`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then(result => result.json())
        .then(response => {
          if (response.length > 0) {
            commit('SET_LAST_CUSTOMER', response[response.length - 1]);
            for (const item of response) {
              item.tags = tags;
            }
            commit('API_SET_MORECUS', response);
          } else {
            commit('LOADING', {
              stateName: 'customersLoadMore',
              status: false,
            });
          }
        })
        .catch(function (error) {
          console.log('error', error);
        });
    },
    async getNextNewCustomerUnread({ state, commit, rootState, dispatch }) {
      // ถ้าไม่สามารถดึงลูกค้าเองได้ จะข้ามการดึงข้อมูล

      if (state.serverConfig.updated == false) {
        console.log('load configuration first time');
        await dispatch('getPublicConfig');
      }
      console.log(
        'state.serverConfig.assign_customer',
        state.serverConfig.assign_customer,
      );
      if (state.serverConfig.assign_customer !== 'pull_by_reservation') {
        commit('newCustomerList', []);
        return [];
      }
      console.log(rootState.reservationId, 'rootState.reservationId');
      const result = await apiChat.get('/nextNewCustomerUnread', {
        params: { reservationId: rootState.reservationId },
      });
      console.log('result', result.data);
      // ห้าม set state hasNewCustomer ใน function นี้

      commit('newCustomerList', result.data);
      return result.data;
    },
    async getSelfCustomerNoReply({ rootState }) {
      // ใช้ดูว่ายังมีคนที่ค้างตอบรึเปล่า
      const result = await apiChat.get('/selfCustomerNoReply', {
        params: { reservationId: rootState.reservationId },
      });
      return result.data || [];
    },
    async getCanTakeCustomerQueues({ rootState }) {
      // เรียก api ว่าดึงลูกค้าคิวไหนได้บ้าง
      const result = await apiChat.get('/getCanTakeCustomerQueues', {
        params: { reservationId: rootState.reservationId },
      });
      if (result.data && result.data.value) {
        // ['ready','normal']
        return result.data.value;
      }
      return [];
    },
    async pushNextCustomerToChatList({ commit, state, rootState, dispatch }) {
      commit('pushNextCustomerOnLoad', false); // ปรับสถานะ ไม่ให้โหลดซ้ำ
      if (state.newCustomerList.length === 0) {
        return;
      }
      const queues = await dispatch('getCanTakeCustomerQueues');
      const nextCustomerFilter = state.newCustomerList.filter(
        nc =>
          (nc.customer.isReadyQueue && queues.includes('ready')) ||
          queues.includes('normal'),
      );
      if (nextCustomerFilter.length === 0) {
        return;
      }
      const [nextCustomer] = nextCustomerFilter;

      // emit socket บอก reservation คนอื่น ว่ารับลูกค้าไปแล้ว (ดึงออกจาก list)
      await apiChat.post('/socketEmitSetResMain', {
        customerId: nextCustomer.customer.customerId,
        reservationId: rootState.reservationId,
      });

      // update owner reservation
      const setResMainResult = await apiChat.post('/setCustomerOwnerByRes', {
        customerId: nextCustomer.customer.customerId,
        reservationId: rootState.reservationId,
      });
      console.log('set resmain result', setResMainResult.data);
      // ถ้ายังไม่มีคนรับ ให้รับลูกค้า แล้ว push message ล่าสุดเข้าไปที่กล่อง chat บนสุด

      const lastMessageCustomer = await apiChat.get('/lastCustomerMessage', {
        params: { customerId: nextCustomer.customer.customerId },
      });
      const msg = lastMessageCustomer.data;
      const chatMsg = {
        ...msg,
        text: msg.latestMsg,
        time: msg.lastMessageTime,
      };
      commit('SOCKET_NEW_MESSAGE', chatMsg);
      dispatch('setActiveChatCustumer', chatMsg);
    },
    async holdActiveChatCustomer({ state, rootState, commit }) {
      try {
        const requestResult = await apiChat.post('setCustomerHold', {
          customerId: state.activeChatCustomer.custId,
          reservationId: rootState.reservationId,
        });

        if (requestResult.data) {
          commit(' ', {
            ...state.activeChatCustomer,
            hold: true,
          });
          // find customer in list message
          const cust = state.customers.filter(
            m => m.custId == state.activeChatCustomer.custId,
          );
          if (cust.length > 0) {
            cust[0].hold = true;

            commit('customers', state.customers);
          }

          return true;
        } else {
          return false;
        }
      } catch (ex) {
        return false;
      }
    },
    async unHoldActiveChatCustomer({ state, rootState, commit }) {
      try {
        const requestResult = await apiChat.post('setCustomerUnHold', {
          customerId: state.activeChatCustomer.custId,
          reservationId: rootState.reservationId,
        });

        if (requestResult.data) {
          commit('activeChatCustomer', {
            ...state.activeChatCustomer,
            hold: false,
          });
          // find customer in list message
          const cust = state.customers.filter(
            m => m.custId == state.activeChatCustomer.custId,
          );
          if (cust.length > 0) {
            cust[0].hold = false;

            commit('customers', state.customers);
          }

          return true;
        } else {
          return false;
        }
      } catch (ex) {
        return false;
      }
    },
    async getHandleNoReplyCustomerCount({ rootState }) {
      // ดึงว่าสามารถค้างรับลูกค้าได้กี่คน ที่ยังไม่ตอบ
      try {
        const result = await apiChat.get(
          `reservations/${rootState.reservationId}`,
        );
        if (!result.data) {
          return 0;
        }
        return result.data.handleNoReplyCustomerCount || 0;
      } catch (ex) {
        return 0;
      }
    },
    async getPublicConfig({ commit }) {
      try {
        const req = await apiChat.get('configurations/public');
        commit('serverConfig', req.data);
        return req.data;
      } catch (err) {
        console.log(err);
        return {};
      }
    },
    loadResTeam({ commit, state }, type) {
      console.log('loadResTeam');
      console.log('localStorage.getItem : ', localStorage.getItem('resteam'));
      //  if (localStorage.getItem('resteam') == null) {

      const options = {
        method: 'GET',
        url:
          'https://n8n.service.mushroomtravel.com/webhook/chat/getTeamMember',
      };
      // var _promiseresteam = new Promise(resolve => {
      axios(options)
        .then(function (response) {
          if (response.status == 200 && response.data != null) {
            //commit('SET_STICKERS_AND_OFTENIMAGE', response.data);
            // resolve(response.data);
            console.log('response.data', response.data);
            commit('SET_RESERVATION_TEAM', response.data);
            localStorage.setItem('resteam', JSON.stringify(response.data));
          }
        })
        .catch(function (error) {
          console.log('error', error);
        });
      // });
      // localStorage.setItem('resteam' , _promiseresteam);
      //return _promiseresteam;
      // } else {
      //return localStorage.getItem('resteam');
      //  }
    },
    // AI Suggestion Actions
    async loadAiSuggestionStatus({ commit, state }, customerId) {
      if (!customerId) return;
      commit('SET_AI_SUGGEST_LOADING', true);
      try {
        const response = await apiChat.get(`/suggestion/customer/${customerId}/status`);
        if (response.data && response.data.success) {
          const { globalEnabled, autoTriggerEnabled, customerAutoTriggerEnabled } = response.data.data;
          commit('SET_AI_SUGGEST_GLOBAL_ENABLED', globalEnabled);
          commit('SET_AI_SUGGEST_AUTO_TRIGGER_ENABLED', autoTriggerEnabled);
          commit('SET_AI_SUGGEST_CUSTOMER_ENABLED', customerAutoTriggerEnabled);
        }
      } catch (error) {
        console.error('Error loading AI suggestion status:', error);
        // Default to disabled on error
        commit('SET_AI_SUGGEST_GLOBAL_ENABLED', false);
        commit('SET_AI_SUGGEST_CUSTOMER_ENABLED', false);
      } finally {
        commit('SET_AI_SUGGEST_LOADING', false);
      }
    },
    async toggleAiSuggest({ commit, state }, { customerId, enabled }) {
      if (!customerId) return;
      commit('SET_AI_SUGGEST_LOADING', true);
      try {
        const response = await apiChat.put(`/suggestion/customer/${customerId}/toggle`, {
          enabled,
        });
        if (response.data && response.data.success) {
          const { suggestEnabled } = response.data.data;
          // Only update customer-specific toggle, not globalEnabled
          commit('SET_AI_SUGGEST_CUSTOMER_ENABLED', suggestEnabled);
          // Clear suggestions if disabled
          if (!suggestEnabled) {
            commit('CLEAR_AI_SUGGESTIONS');
          }
        }
      } catch (error) {
        console.error('Error toggling AI suggestion:', error);
      } finally {
        commit('SET_AI_SUGGEST_LOADING', false);
      }
    },
    requestAiSuggestions({ state }, customerId) {
      if (!_socket || !customerId) return;
      console.log('Requesting AI suggestions for:', customerId);
      _socket.emit('getSuggestions', customerId);
    },
    async loadAiSuggestionsRest({ commit, state }, customerId) {
      if (!customerId) return;
      commit('SET_AI_SUGGEST_LOADING', true);
      try {
        const response = await apiChat.get(`/suggestions/${customerId}`, {
          params: { limit: 3 },
        });
        if (response.data && response.data.success) {
          const suggestions = (response.data.data || []).map(s => ({
            suggestionId: s._id,
            messageId: s.messageId,
            chatHistoryId: s.chatHistoryId,
            chatHistoryIds: s.chatHistoryIds || (s.chatHistoryId ? [s.chatHistoryId] : []),
            customerId: s.customerId,
            suggestedReply: s.suggestedReply,
            alternativeReplies: s.alternativeReplies || [],
            intent: s.detectedIntent,
            confidence: s.intentConfidence,
            feedback: s.feedback || { isCorrect: null },
            used: s.used || { isUsed: false },
            source: s.source || 'auto',
            createdAt: s.createdAt,
            customerMessageAt: s.customerMessageAt,
          }));
          // Sort by createdAt ascending (oldest on top)
          suggestions.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
          // Manual suggestions go on top, then auto sorted by date
          const existingManual = state.aiSuggestions.filter(
            s => s.source === 'manual' && !suggestions.find(ns => ns.suggestionId === s.suggestionId)
          );
          commit('SET_AI_SUGGESTIONS', [...existingManual, ...suggestions]);
        }
      } catch (error) {
        console.error('Error loading AI suggestions:', error);
        // On error, keep existing manual suggestions
        const existingManual = state.aiSuggestions.filter(s => s.source === 'manual');
        commit('SET_AI_SUGGESTIONS', existingManual);
      } finally {
        commit('SET_AI_SUGGEST_LOADING', false);
      }
    },
    async submitSuggestionFeedback({ commit, rootState }, { suggestionId, isCorrect, feedbackNote, actualReplyUsed }) {
      if (!suggestionId) return;
      try {
        const response = await apiChat.post(`/suggestion/${suggestionId}/feedback`, {
          isCorrect,
          reservationId: rootState.reservationId,
          feedbackNote: feedbackNote || '',
          actualReplyUsed: actualReplyUsed || '',
        });
        if (response.data && response.data.success) {
          commit('UPDATE_AI_SUGGESTION_FEEDBACK', { suggestionId, isCorrect });
        }
      } catch (error) {
        console.error('Error submitting suggestion feedback:', error);
      }
    },
    async dismissSuggestion({ rootState }, suggestionId) {
      if (!suggestionId) return;
      try {
        await apiChat.post(`/suggestion/${suggestionId}/dismiss`, {
          reservationId: rootState.reservationId,
        });
      } catch (error) {
        console.error('Error dismissing suggestion:', error);
      }
    },
    async manualSuggest({ commit, state }, { chatHistoryIds, customerId }) {
      if (!customerId) return null;
      // Filter to valid MongoDB ObjectIds, empty array = backend auto-flush
      const validIds = (chatHistoryIds || []).filter(id => typeof id === 'string' && /^[a-f0-9]{24}$/.test(id));
      commit('SET_AI_SUGGEST_LOADING', true);
      try {
        const response = await apiChat.post('/suggestion/manual', {
          chatHistoryIds: validIds,
          customerId,
        });
        // Verify customer is still active (prevent race condition on customer switch)
        if (state.activeChatCustomer && state.activeChatCustomer.custId !== customerId) {
          console.log('manualSuggest: customer changed during API call, discarding result');
          return null;
        }
        if (response.data && response.data.success) {
          const s = response.data.data;
          const suggestion = {
            suggestionId: s._id,
            messageId: s.messageId,
            chatHistoryId: s.chatHistoryId,
            chatHistoryIds: s.chatHistoryIds || [],
            customerId: s.customerId,
            suggestedReply: s.suggestedReply,
            alternativeReplies: s.alternativeReplies || [],
            intent: s.detectedIntent,
            confidence: s.intentConfidence,
            feedback: s.feedback || { isCorrect: null },
            used: s.used || { isUsed: false },
            source: s.source || 'manual',
            isExisting: response.data.isExisting || false,
            customerMessageAt: s.customerMessageAt,
          };
          commit('ADD_AI_SUGGESTION', suggestion);
          return suggestion;
        }
        return null;
      } catch (error) {
        console.error('Error calling manual suggest:', error);
        return null;
      } finally {
        commit('SET_AI_SUGGEST_LOADING', false);
      }
    },

    // Message draft actions for per-customer input persistence
    saveMessageDraft(_, { custId, text, suggestionId }) {
      saveMessageDraft(custId, text, suggestionId);
    },
    getMessageDraft(_, custId) {
      return getMessageDraft(custId);
    },

    async loadCountTagPaidAndUnpaid({ state, dispatch, rootState, commit }, ReservationTeams) {
      console.log('+==========================================+');
      console.log('          loadCountTagPaidAndUnpaid');
      console.log('+==========================================+');
      //console.log('localStorage.getItem : ', localStorage.getItem('resteam'));
      //  if (localStorage.getItem('resteam') == null) {
      let customerTeam = state.customerTeams;
      const ResTeam = fnLoadResTeam();
      console.log('customerTeam  : ', customerTeam);
      console.log('load ResTeam  : ', ResTeam);
      console.log('state.searchNotResponse  : ', state.searchNotResponse);
      console.log('rootState.reservationId  : ', rootState.reservationId);
      const data = {
        resMain: rootState.reservationId
          ? String(rootState.reservationId) +
          (ResTeam[customerTeam] ? ',' + ResTeam[customerTeam] : '')
          : undefined, // -- ถ้าเป็น TEAM List ResID
        isWaitReply: state.searchNotResponse,
      };
      console.log('data : ', data);
      const options = {
        method: 'POST',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: qs.stringify(data),
        url: API_CHAT + '/computeTotalTagPayment',
      };
      return new Promise(resolve => {
        axios(options)
          .then(function (response) {
            if (response.data && response.data.length > 1) {
              commit('SET_PAIDCOUNT', response.data[0].totalCount);
              commit('SET_UNPAIDCOUNT', response.data[1].totalCount);
            }
            console.log('computeTotalTagPayment.response : ', response.data[0]._id);
            console.log('computeTotalTagPayment.response : ', response.data[0].totalCount);
            console.log('computeTotalTagPayment.response : ', response.data[1]._id);
            console.log('computeTotalTagPayment.response : ', response.data[1].totalCount);
            resolve();
          })
          .catch(function (error) {
            console.log('error', error);
          });
      });
    },
  },
  getters: {
    customers: state => {
      return state.customers;
    },
    customersLoading: state => {
      return state.customersLoading;
    },
    messages: state => {
      return state.messages;
    },
    messagesLoading: state => {
      return state.messagesLoading;
    },
    activeChatCustomer: state => {
      return state.activeChatCustomer;
    },
    activeChatCustomerName: state => {
      const active = state.activeChatCustomer;
      if (!active) {
        return '';
      }
      if (active.custNameNew) {
        return active.custNameNew;
      }
      return active.custName;
    },
    lastMessage: state => {
      return state.lastMessage;
    },
    newMessage: state => {
      return state.newMessage;
    },
    msgSuccess: state => {
      return state.msgSuccess;
    },
    msgCount: state => {
      return fnCountMsgAll(state.customers);
    },
    msgCountNotHold: state => {
      return state.customers.reduce(
        (prev, curr) => prev + (curr.hold ? 0 : curr.count),
        0,
      );
    },
    searchCustomersMessage: state => {
      return state.searchCustomersMessage;
    },
    quickReplyTemplates: state => {
      return state.quickReplyTemplates;
    },
    quickReplyExpandedCode: state => {
      return state.quickReplyExpandedCode;
    },
    quickReplyLoading: state => {
      return state.quickReplyLoading;
    },
    quickReplyProcessed: (state, getters, rootState) => {
      const profile = rootState.profile ? rootState.profile.profile : null;
      if (!state.quickReplyTemplates || !state.quickReplyTemplates.length) return [];
      return state.quickReplyTemplates.map(item => {
        const processed = {
          ...item,
          content: substituteQuickReplyVars(item.content, profile),
        };
        if (item.children && item.children.length) {
          processed.children = item.children.map(child => ({
            ...child,
            content: substituteQuickReplyVars(child.content, profile),
          }));
        }
        return processed;
      });
    },
    msgId: state => {
      return state.msgId;
    },
    connect: state => {
      return state.connect;
    },
    firstMessage: state => {
      return state.firstMessage;
    },
    scrollStatus: state => {
      return state.scrollStatus;
    },
    messageScroll: state => {
      return state.messageScroll;
    },
    msgCountAll: state => {
      return state.msgCountAll;
    },
    paidCountAll: state => {
      return state.paidCountAll;
    },
    unpaidCountAll: state => {
      return state.unpaidCountAll;
    },
    searchContactCustomer: state => {
      return state.searchContactCustomer;
    },
    productDetail: state => {
      return state.productDetail;
    },
    mouthProduct: state => {
      return state.mouthProduct;
    },
    periodsProduct: state => {
      return state.periodsProduct;
    },
    productLoading: state => {
      return state.productLoading;
    },
    refLoading: state => {
      return state.refLoading;
    },
    loadMore: state => {
      return state.loadMore;
    },
    numPeriods: state => {
      return state.numPeriods;
    },
    sickersAndOftenImage: state => {
      return state.sickersAndOftenImage;
    },
    typeOpenChat: state => {
      return state.typeOpenChat;
    },
    loading: state => state.loading,
    customersLoadMoreLoading: state => state.customersLoadMoreLoading,
    // AI Suggestion getters
    aiSuggestions: state => state.aiSuggestions,
    aiSuggestEnabled: state => state.aiSuggestCustomerEnabled,
    aiSuggestLoading: state => state.aiSuggestLoading,
    aiSuggestGlobalEnabled: state => state.aiSuggestGlobalEnabled,
    aiSuggestAutoTriggerEnabled: state => state.aiSuggestAutoTriggerEnabled,
    latestAiSuggestion: state => {
      if (state.aiSuggestions.length === 0) return null;
      return state.aiSuggestions[state.aiSuggestions.length - 1];
    },
  },
};

function fnSetMessageModel(item) {
  if (!item) return item;
  if (
    item.custName == 'Mapper' ||
    // item.custName == 'Me' ||
    item.sender == 'R'
  ) {
    item.isType = true;
  } else {
    item.isType = false;
  }
  item.isUpload = false;
  // Backward compatibility: default pushStatus for old messages
  if (item.pushStatus === undefined) {
    item.pushStatus = 'success';
  }
  if (item.pushError === undefined) {
    item.pushError = null;
  }
  if (item.pushAttempts === undefined) {
    item.pushAttempts = 0;
  }
  // Messages from server are NOT client errors - they should use retry endpoint
  if (item.isClientError === undefined) {
    item.isClientError = false;
  }
  // Keep statusSendMessage derived from pushStatus
  item.statusSendMessage = item.pushStatus !== 'failed';
  // Preserve MongoDB ObjectId as chatHistoryId (distinct from LINE messageId)
  // _id from getlisthitory/getChatHistory is the MongoDB ObjectId
  // _id from SOCKET_NEW_MESSAGE is the LINE messageId (overwritten)
  if (!item.chatHistoryId && item._id && typeof item._id === 'string' && /^[a-f0-9]{24}$/.test(item._id)) {
    item.chatHistoryId = item._id;
  }
  return item;
}
function fnCountMsgAll(cus) {
  var num = 0;
  cus.forEach(item => {
    num += item.count;
  });
  return num;
}
function fnCheckDayrank(mouth, period) {
  var mapRank = map(period, function (val) {
    var day = parseInt(val.d);
    if (day <= 10 && day != 0) {
      val.date = '1-10';
    }
    if (day >= 11 && day <= 20) {
      val.date = '11-20';
    }
    if (day >= 21 && day <= 31) {
      val.date = '21-31';
    }
    return val;
  });

  var setGroupArray = map(groupBy(mapRank, 'date'), function (value, index) {
    return { date: index, items: value, key: index + '-' + mouth };
  });
  return setGroupArray;
}
function fnSetPeriodDate(period) {
  if (period) {
    let p = period.split(' ');
    let datePeriod = p[0] + ' ' + p[1];
    return datePeriod;
  }
}

function fnsetFormatPrice(newValue) {
  return (
    '฿' + newValue.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  );
}

function fnFormatAllotWarning(allotDate) {
  // disable temporary
  return '';
  if (!allotDate) return '';

  const allot = new Date(allotDate);
  const now = new Date();

  // Get date-only for comparison (in local timezone)
  const todayDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const tomorrowDate = new Date(todayDate);
  tomorrowDate.setDate(tomorrowDate.getDate() + 1);
  const allotDateOnly = new Date(allot.getFullYear(), allot.getMonth(), allot.getDate());

  // Format time in 24h format
  const hours = String(allot.getHours()).padStart(2, '0');
  const minutes = String(allot.getMinutes()).padStart(2, '0');
  const timeStr = hours + ':' + minutes + ' น.';

  if (allotDateOnly.getTime() === todayDate.getTime()) {
    return ' ⚠️ ตัดที่วันนี้ ' + timeStr;
  } else if (allotDateOnly.getTime() === tomorrowDate.getTime()) {
    return ' ⚠️ ตัดที่พรุ่งนี้ ' + timeStr;
  }

  return '';
}

//7445,15502,14158,7408,14576,15793,15668,15132,15582,
function fnLoadResTeam() {
  console.log('loadResTeam');
  if (localStorage.getItem('resteam') == null) {
    return {
      a: '7445,15502,15668,14158,15582,7408,15132,16021,16111',
      b: '12257,15810,15518,14175,14600,15667,15793,15792,14510,14600,16098,16110,16148',
    };
  } else {
    console.log('Return from localStorage');
    return JSON.parse(localStorage.getItem('resteam'));
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Chat.js